import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';

import Geosuggest from 'react-geosuggest';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import './About.css';
import { EventViewSplitPane } from './Event'
import RichTextEditor from './RichTextEditor';
import DatePicker from './DatePicker'
import Roles from './Roles';
import { Modal, WeightHeightPicker, ComboBox, UserPicker, ItemPicker, PublicityPicker, PhonePicker, ConfirmModal, EmptyState } from './Common';
import { AddSportPlay, AddSportFollow, } from '../App';

export default class About extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: "Overview",
      isParentEdit: false,
      userTabs: ["About", "Sports", "Teams"],
      userActiveTab: "About",
      clubActiveTab: "About",
      activeSportTab: "Sports I Play",
      activeTeamTab: "My Teams",
      memberTypes: ['mother', 'mom', 'father', 'dad', 'parent', 'children', 'son', 'daughter', 'sister', 'brother', 'grandmother', 'grandfather', 'grandparent', 'grandson', 'granddaughter', 'grandchild', 'aunt', 'uncle', 'niece', 'nephew', 'cousin', 'husband', 'wife', 'sister-in-law', 'brother-in-law', 'mother-in-law', 'father-in-law', 'partner', 'fiancé', 'fiancée', 'stepmother', 'stepfather', 'ex'],
      newWork: {
        name: "",
        position: "",
        city: "",
        period: {
          from: "",
          to: ""
        }
      },
      isAddingWork: false,
      isAddingCity: false,
      isAddingSchool: false,
      isAddingCollege: false,
      isAddingSociakl: false,
      isAddingMember: false,
      isAddingRole: false,
      newSocial: {
        key: "",
        value: ""
      },
      newCollege: {
        name: "",
        city: "",
        type: "college",
        period: {
          from: "",
          to: ""
        }
      },
      newSchool: {
        name: "",
        city: "",
        type: "school",
        period: {
          from: "",
          to: ""
        }
      },
      newMember: {
        user: null,
        type: "family",
        privacy: 1,
        tag: null
      }
    }

    //console.log(this.props);
  }

  componentDidMount() {
    if (this.state.activeTab === "Overview" && this.props.isChildEmbed) {
      this.setState({ activeTab: "Personal Info" });
    }
  }

  onWorkSave(work, cb) {
    //console.log(work)
    const _that = this;
    const dataTo = {
      user: this.props.profile,
      work: work
    }

    FakeData.post("/addWorkPlace.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({
          isAddingWork: false,
          newWork: {
            name: "",
            position: "",
            city: "",
            period: {
              from: "",
              to: ""
            }
          }
        })

        cb.call(this)
      }),
      error: ((err) => {

      })
    }, true, "Data Saved!", ((res) => {

    }))
  }

  onCollgeSave(college, cb) {
    const _that = this;
    const dataTo = {
      user: this.props.profile,
      school: college
    }

    FakeData.post("/addSchool.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({
          isAddingCollege: false,
          newCollege: {
            name: "",
            city: "",
            type: "college",
            period: {
              from: "",
              to: ""
            }
          }
        })
        cb.call(this)
      }),
      error: ((err) => {

      })
    }, true, "Data Saved!", ((res) => {

    }))
  }

  onSchoolSave(school, cb) {
    const _that = this;
    const dataTo = {
      user: this.props.profile,
      school: school
    }

    FakeData.post("/addSchool.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({
          isAddingSchool: false,
          newSchool: {
            name: "",
            city: "",
            type: "school",
            period: {
              from: "",
              to: ""
            }
          }
        })
        cb.call(this)
      }),
      error: ((err) => {
        //console.log(err)
      })
    }, true, "Data Saved!", ((res) => {

    }))
  }

  onCitySave(city, cb) {
    const _that = this;
    const dataTo = {
      user: this.props.profile,
      place: city
    }

    FakeData.post("/editPlace.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({
          isAddingCity: false
        })
        cb.call(this)
      }),
      error: ((err) => {
        //console.log(err)
      })
    }, true, "Data Saved!", ((res) => {

    }))
  }

  addMember() {
    const _that = this;
    const dataTo = {
      user: this.props.profile,
      data: this.state.newMember
    }

    if (this.state.newMember.user === null) {
      alert("Select A Person");
      return
    }

    if (this.state.newMember.tag === null) {
      alert("Select Relationship");
      return
    }

    FakeData.post("/addRelationShip.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({
          newMember: {
            user: null,
            type: "family",
            privacy: 1,
            tag: null
          },
          isAddingMember: false
        })
      }),
      error: ((err) => {

      })
    }, true, "Data Saved!", ((res) => { }))
  }

  render() {
    const profile = this.props.profile;
    const { isParent } = this.props;
    //console.log(this.state.newMember)
    if (this.props.isChildEmbed) {
      return (
        <div className="default-view" style={{ backgroundColor: "#fff", paddingBottom: "20px" }}>
          {(!this.props.hideTabs && this.props.state === "user") &&
            <div className="view-with-tabs">
              <div className="view-with-tabs-body">
                {this.state.userActiveTab === "About" &&
                  <EventViewSplitPane isExtended="true" active={this.state.activeTab} items={["Personal Info", "Parents", "Coaches", "Emergency Info", "Medical Info"]} setView={(d) => {
                    this.setState({
                      activeTab: d
                    });
                  }}>
                    {(this.state.activeTab === "Personal Info" && !this.state.isParentEdit) &&
                      <div className="overview-about">
                        <div className="main-view">
                          <AboutLabel title={"Full Name"} isAdmin={isParent} value={profile.name} onClick={() => {
                            this.setState({
                              isParentEdit: true
                            });
                          }} />

                          <AboutLabel title={"D.O.B"} isAdmin={isParent} value={profile.dob + " (" + profile.age + ")"} onClick={() => {
                            this.setState({
                              activeTab: "Work & Education"
                            });
                          }} />

                          {!profile.isUnderAge &&
                            <AboutLabel title={(Array.isArray(profile.work.current)) ? "Work place not set" : profile.work.current.position + " at " + profile.work.current.name} isAdmin={false} value={(profile.work.past === null) ? "" : "Past : " + profile.work.past.position + " at " + profile.work.past.name} onClick={() => {
                              this.setState({
                                activeTab: "Work & Education"
                              });
                            }} />
                          }
                          {!profile.isUnderAge &&
                            <AboutLabel title={(Array.isArray(profile.education.current)) ? "Education not set" : "Studies at " + profile.education.current.name} isAdmin={false} value={(profile.education.past.length === 0) ? "" : "Past : Studied at " + profile.education.past[0].name} onClick={() => {
                              this.setState({
                                activeTab: "Work & Education"
                              });
                            }} />
                          }

                          <AboutLabel title={"Physical Address"} isAdmin={isParent} value={profile.address} onClick={() => {
                            this.setState({
                              activeTab: "Work & Education"
                            });
                          }} />

                          <AboutLabel title={"Suburb"} isAdmin={isParent} value={profile.suburb} onClick={() => {
                            this.setState({
                              activeTab: "Work & Education"
                            });
                          }} />

                          <AboutLabel title={"State/Province"} isAdmin={isParent} value={profile.state} onClick={() => {
                            this.setState({
                              activeTab: "Work & Education"
                            });
                          }} />

                          <AboutLabel title={"Postal Code"} isAdmin={isParent} value={profile.postal} onClick={() => {
                            this.setState({
                              activeTab: "Work & Education"
                            });
                          }} />

                          <AboutLabel title={"Country"} isAdmin={isParent} value={profile.country} onClick={() => {
                            this.setState({
                              activeTab: "Work & Education"
                            });
                          }} />
                        </div>
                        <div className="side-view">
                          <div className="side-view-contacts">
                            <div className="side-view-contact">
                              <img src="images/mobile_icon.svg" />
                              <span>{profile.contacts.personal[0].value}</span>

                            </div>
                            <div className="side-view-contact">
                              <img src="images/landline_icon.svg" />
                              <span>{profile.contacts.personal[1].value}</span>

                            </div>
                            <div className="side-view-contact">
                              <img src="images/email_icon.svg" />
                              <span>{profile.contacts.personal[2].value}</span>

                            </div>
                            {!profile.isUnderAge &&
                              <div className="side-view-contact">
                                <img src="images/website_icon.svg" />
                                <span>{profile.contacts.personal[3].value}</span>
                              </div>
                            }
                          </div>
                          <div className="side-view-socials">
                            {
                              profile.contacts.social.map((item, i) => {
                                return (
                                  <a key={i}>
                                    <img src={item.icon} className="profile_social_icons" />
                                  </a>
                                )
                              })
                            }

                          </div>
                        </div>
                      </div>
                    }

                    {(this.state.activeTab === "Personal Info" && this.state.isParentEdit && isParent) &&
                      <div className="contact-about" style={{ position: "relative" }}>
                        <h4>Personal Information</h4>
                        <i className={"material-icons"} style={{ position: "absolute", right: 0, top: 0, fontSize: 16, color: "#345", marginRight: "20px" }} onClick={() => {
                          this.setState({ isParentEdit: false });
                        }}>close</i>
                        <AboutBasicEdit isTextInput={true} isUser={true} value={profile.first_name} label="Name" type="" isAdmin={profile.isAdmin} fieldType={"F"} field={"name"} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=users&q=user_id" />
                        <AboutBasicEdit isTextInput={true} isUser={true} value={profile.last_name} label="Surname" type="" isAdmin={profile.isAdmin} fieldType={"F"} field={"surname"} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=users&q=user_id" />

                        <AboutBasicEdit isTeleInput={true} value={profile.contacts.personal[0].value} label="Mobile" type="number" isAdmin={profile.isAdmin} url="updateMetaData.php?auth0" field={profile.contacts.personal[0].rawKey} privacy={profile.contacts.personal[0].privacy} fieldId={profile.id} />
                        <AboutBasicEdit isTeleInput={true} value={profile.contacts.personal[1].value} label="Telephone" type="number" isAdmin={profile.isAdmin} url="updateMetaData.php?auth0" field={profile.contacts.personal[1].rawKey} privacy={profile.contacts.personal[1].privacy} fieldId={profile.id} />
                        <AboutSocialEdit profile={profile} label="Social Links" isAdmin={profile.isAdmin} type="P" socials={profile.contacts.social} />
                        <AboutBasicEdit isTextInput={true} isWeb={true} value={profile.contacts.personal[3].value} label="Website" isLink="true" href={profile.contacts.personal[3].value} type="website" isAdmin={profile.isAdmin} url="updateMetaData.php?auth0" field={profile.contacts.personal[3].rawKey} privacy={profile.contacts.personal[3].privacy} fieldId={profile.id} />
                        <AboutBasicEdit isTextInput={true} isEmail={true} value={profile.contacts.personal[2].value} label="Email" isLink="true" href={"mailto:" + profile.contacts.personal[2].value} type="email" isAdmin={profile.isAdmin} url="updateMetaData.php?auth0" field={profile.contacts.personal[2].rawKey} privacy={profile.contacts.personal[2].privacy} fieldId={profile.id} />

                        <AboutBasicEdit isTextInput={true} isUser={true} value={profile.address} label="Physical Address" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=users&q=user_id" fieldType={"F"} field={"user_address"} privacy={""} fieldId={profile.id} />

                        <AboutBasicEdit isTextInput={true} isUser={true} value={profile.suburb} label="Suburb" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=users&q=user_id" fieldType={"F"} field={"user_suburb"} privacy={""} fieldId={profile.id} />

                        <AboutBasicEdit isRegionPicker={true} mode={"state"} isUser={true} value={profile.state} label="State/Province" type="" isAdmin={profile.isAdmin} fieldType={"F"} field={"user_state"} country={profile.country} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=users&q=user_id" />

                        <AboutBasicEdit isTextInput={true} isUser={true} value={profile.postal} label="Postal Code" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=users&q=user_id" fieldType={"F"} field={"user_postal"} privacy={""} fieldId={profile.id} />

                        <AboutBasicEdit isRegionPicker={true} mode={"country"} isUser={true} value={profile.country} label="Country" type="" isAdmin={profile.isAdmin} fieldType={"F"} field={"user_country"} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=users&q=user_id" />

                        <button className={"button"} onClick={() => {
                          this.setState({ isParentEdit: false });
                        }}>Save</button>

                      </div>
                    }

                    {(this.state.activeTab === "Parents") &&
                      <div className="contact-about">
                        <h4>{profile.name + "'s Parents"}</h4>
                        <div className="family-members">
                          {
                            profile.parents.map((item, i) => {
                              return (
                                <FamilyMember roleId={item.id} isRole={true} role={item.role} key={i} user={item.user} isAdmin={false} />
                              )
                            })
                          }

                        </div>
                      </div>
                    }

                    {(this.state.activeTab === "Coaches") &&
                      <div className="contact-about">
                        <h4>{profile.name + "'s Coaches"}</h4>
                        <div className="family-members">
                          {
                            profile.coaches.map((item, i) => {
                              return (
                                <FamilyMember roleId={item.id} isRole={true} role={item.role} key={i} user={item.user} isAdmin={false} />
                              )
                            })
                          }

                        </div>
                      </div>
                    }
                    {(this.state.activeTab === "Emergency Info") &&
                      <div className="contact-about">
                        <h4>{profile.name + "'s emergency information"}</h4>
                        <AdditionalInformation key={"e"} type={"F"} isMedical={false} profile={profile} isAdmin={isParent} />
                      </div>
                    }
                    {(this.state.activeTab === "Medical Info") &&
                      <div className="contact-about">
                        <h4>{profile.name + "'s medical information"}</h4>
                        <AdditionalInformation key={"m"} type={"F"} isMedical={true} profile={profile} isAdmin={isParent} />
                      </div>
                    }

                    {(this.state.activeTab === "Details About You") &&
                      <div className="contact-about">
                        <h4>About</h4>
                        <AboutBioEdit fieldType={"F"} privacy={profile.aboutPrivacy} value={profile.about} label={""} type="text" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=users&q=user_id" field={"about_user"} privacyField={"about_privacy"} fieldId={profile.id} />
                        <h4>More Information</h4>
                        <AdditionalInformation type={"F"} profile={profile} isAdmin={profile.isAdmin} />
                      </div>
                    }
                  </EventViewSplitPane>
                }
              </div>
            </div>
          }
        </div>
      )
    }

    return (
      <div className="default-view" style={{ backgroundColor: "#fff", paddingBottom: "20px" }}>
        {(this.props.hideTabs && this.props.state === "team") &&
          <EventViewSplitPane isExtended="true" active={this.state.activeTab} items={["Overview", "Contact & Basic Info", "People"]} setView={(d) => {
            this.setState({
              activeTab: d
            });
          }}>
            {(this.state.activeTab === "Overview") &&
              <div className="overview-about">
                <div className="main-view">
                  <AboutLabel title="Manager" isAdmin={profile.isAdmin} value={profile.manager.name} onClick={() => {
                    this.setState({
                      activeTab: "People"
                    });
                  }} />
                  <AboutLabel title="Captain" isAdmin={profile.isAdmin} value={profile.captain.name} onClick={() => {
                    this.setState({
                      activeTab: "People"
                    });
                  }} />
                  <AboutLabel title="Founded" isAdmin={profile.isAdmin} value={profile.establishMonth + ', ' + profile.establishYear} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />
                  <AboutLabel title={"Physical Address"} isAdmin={profile.isAdmin} value={profile.address} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />

                  <AboutLabel title={"Suburb"} isAdmin={profile.isAdmin} value={profile.suburb} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />

                  <AboutLabel title={"State/Province"} isAdmin={profile.isAdmin} value={profile.state} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />

                  <AboutLabel title={"Postal Code"} isAdmin={profile.isAdmin} value={profile.postal} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />

                  <AboutLabel title={"Country"} isAdmin={profile.isAdmin} value={profile.country} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />
                  <AboutLabel title="Background Information" isRichText={true} isAdmin={profile.isAdmin} value={profile.about} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />


                </div>
                <div className="side-view">
                  <div className="side-view-contacts">
                    <div className="side-view-contact">
                      <img src="images/mobile_icon.svg" />
                      <span>{profile.contactMain}</span>
                      {profile.isAdmin &&
                        <i className="material-icons" onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }}>settings</i>
                      }
                    </div>
                    <div className="side-view-contact">
                      <img src="images/landline_icon.svg" />
                      <span>{profile.contactOther}</span>
                      {profile.isAdmin &&
                        <i className="material-icons" onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }}>settings</i>
                      }
                    </div>
                    <div className="side-view-contact">
                      <img src="images/email_icon.svg" />
                      <span>{profile.email}</span>
                      {profile.isAdmin &&
                        <i className="material-icons" onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }}>settings</i>
                      }
                    </div>
                    <div className="side-view-contact">
                      <img src="images/website_icon.svg" />
                      <span>{profile.website}</span>
                      {profile.isAdmin &&
                        <i className="material-icons" onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }}>settings</i>
                      }
                    </div>
                  </div>
                  <div className="side-view-socials">
                    {
                      profile.socials.map((item, i) => {
                        return (
                          <a key={i}>
                            <img src={item.icon} className="profile_social_icons" />
                          </a>
                        )
                      })
                    }
                    {profile.socials.length === 0 &&
                      <span>Add Social Links</span>
                    }
                    {profile.isAdmin &&
                      <i className="material-icons" onClick={() => {
                        this.setState({
                          activeTab: "Contact & Basic Info"
                        });
                      }}>settings</i>
                    }
                  </div>
                </div>
              </div>
            }

            {(this.state.activeTab === "Contact & Basic Info") &&
              <div className="contact-about">
                <h4>Contact Information</h4>
                <AboutBasicEdit isTeleInput={true} value={profile.contactMain} label="Mobile" type="number" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=teams&q=TeamID" field="ContactNumber" fieldId={profile.id} />
                <AboutBasicEdit isTeleInput={true} value={profile.contactOther} label="Other Phone" type="number" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=teams&q=TeamID" field="OtherContactNumber" fieldId={profile.id} />
                <AboutSocialEdit profile={profile} type="T" label="Social Links" isAdmin={profile.isAdmin} socials={profile.socials} />
                <AboutBasicEdit isTextInput={true} isWeb={true} value={profile.website} label="Website" isLink="true" href={profile.website} type="website" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=teams&q=TeamID" field="Website" fieldId={profile.id} />
                <AboutBasicEdit isTextInput={true} value={profile.email} label="Email" isLink="true" href={"mailto:" + profile.email} type="email" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=teams&q=TeamID" field="Email" fieldId={profile.id} />
                <AboutBasicEdit isTextInput={true} isUser={true} value={profile.address} label="Physical Address" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=teams&q=TeamID" fieldType={"T"} field={"Address"} privacy={""} fieldId={profile.id} />

                <AboutBasicEdit isTextInput={true} isUser={true} value={profile.suburb} label="Suburb" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=teams&q=TeamID" fieldType={"T"} field={"Suburb"} privacy={""} fieldId={profile.id} />

                <AboutBasicEdit isRegionPicker={true} mode={"state"} isUser={true} value={profile.state} label="State/Province" type="" isAdmin={profile.isAdmin} fieldType={"T"} field={"State"} country={profile.country} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=teams&q=TeamID" />

                <AboutBasicEdit isTextInput={true} isUser={true} value={profile.postal} label="Postal Code" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=teams&q=TeamID" fieldType={"T"} field={"PostalCode"} privacy={""} fieldId={profile.id} />

                <AboutBasicEdit isRegionPicker={true} mode={"country"} isUser={true} value={profile.country} label="Country" type="" isAdmin={profile.isAdmin} fieldType={"T"} field={"Country"} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=teams&q=TeamID" />
                <h4>Established</h4>
                <AboutBasicEdit isYearPicker={true} isDatePicker={true} value={profile.establishYear} label={"Year"} type="text" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=teams&q=TeamID" field={"EstablishYear"} fieldId={profile.id} />
                <AboutBasicEdit isDatePicker={true} value={profile.establishMonth} isYearPicker={false} label={"Date"} type="text" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=teams&q=TeamID" field={"EstablishMonth"} fieldId={profile.id} />
                <h4>Background Information</h4>
                <AboutBioEdit privacy={""} fieldType={"T"} value={profile.about} label={""} type="text" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=teams&q=TeamID" field={"History"} privacyField={"HistoryPrivacy"} fieldId={profile.id} />
              </div>
            }
            {(this.state.activeTab === "People") &&
              <div className="contact-about">
                <h4>IMPORTANT PEOPLE</h4>
                <AboutLabelEdit title="Team Manager" isAdmin={profile.isAdmin} value={profile.manager.name} url="/updatePageContacts.php?auth0&ref=teams&q=TeamID" field="Manager" fieldId={profile.id} />
                <AboutLabelEdit title="Team Captain" isAdmin={profile.isAdmin} value={profile.captain.name} url="/updatePageContacts.php?auth0&ref=teams&q=TeamID" field="Captain" fieldId={profile.id} />
                <h4>OTHER PEOPLE</h4>
                {
                  profile.roles.map((item, i) => {
                    return (
                      <AboutClubRoleEdit roles={["Admin Secretary", "Captain", "Chairman", "CFO", "CEO", "Coach", "COO","Editor", "Managing Director", "Player", "Referee", "Receptionist ", "Score Keeper", "Staff Admin"]} title={item.role} isAdmin={profile.isAdmin} item={item} key={item.id} />
                    )
                  })
                }
                {(this.state.isAddingRole && profile.isAdmin) &&
                  <AboutClubRoleEdit toId={profile.id} onAddCallBack={() => this.setState({ isAddingRole: false })} toType={"T"} isNew={true} roles={["Admin Secretary", "Captain", "Chairman", "CFO", "CEO", "Coach", "COO", "Managing Director", "Player", "Referee", "Receptionist ", "Score Keeper", "Staff Admin"]} title={"Add New Role"} isAdmin={profile.isAdmin} key={"new"} />
                }
                {(!this.state.isAddingRole && profile.isAdmin) &&
                  <span className="add-about" onClick={() => this.setState({ isAddingRole: true })}>+ Add Role</span>
                }
              </div>
            }
          </EventViewSplitPane>
        }
        {(this.props.hideTabs && this.props.state === "league") &&
          <EventViewSplitPane isExtended="true" active={this.state.activeTab} items={["Overview", "Contact & Basic Info", "People"]} setView={(d) => {
            this.setState({
              activeTab: d
            });
          }}>
            {(this.state.activeTab === "Overview") &&
              <div className="overview-about">
                <div className="main-view">
                  <AboutLabel title="Manager" isAdmin={profile.isAdmin} value={profile.manager.name} onClick={() => {
                    this.setState({
                      activeTab: "People"
                    });
                  }} />
                  <AboutLabel title="Secretary" isAdmin={profile.isAdmin} value={profile.secretary.name} onClick={() => {
                    this.setState({
                      activeTab: "People"
                    });
                  }} />
                  <AboutLabel title="Founded" isAdmin={profile.isAdmin} value={profile.establishMonth + ', ' + profile.establishYear} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />
                  <AboutLabel title={"Physical Address"} isAdmin={profile.isAdmin} value={profile.address} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />

                  <AboutLabel title={"Suburb"} isAdmin={profile.isAdmin} value={profile.suburb} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />

                  <AboutLabel title={"State/Province"} isAdmin={profile.isAdmin} value={profile.state} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />

                  <AboutLabel title={"Postal Code"} isAdmin={profile.isAdmin} value={profile.postal} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />

                  <AboutLabel title={"Country"} isAdmin={profile.isAdmin} value={profile.country} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />
                  <AboutLabel title="Background Information" isRichText={true} isAdmin={profile.isAdmin} value={profile.about} onClick={() => {
                    this.setState({
                      activeTab: "Contact & Basic Info"
                    });
                  }} />
                </div>
                <div className="side-view">
                  <div className="side-view-contacts">
                    <div className="side-view-contact">
                      <img src="images/mobile_icon.svg" />
                      <span>{profile.contactMain}</span>
                      {profile.isAdmin &&
                        <i className="material-icons" onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }}>settings</i>
                      }
                    </div>
                    <div className="side-view-contact">
                      <img src="images/landline_icon.svg" />
                      <span>{profile.contactOther}</span>
                      {profile.isAdmin &&
                        <i className="material-icons" onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }}>settings</i>
                      }
                    </div>
                    <div className="side-view-contact">
                      <img src="images/email_icon.svg" />
                      <span>{profile.email}</span>
                      {profile.isAdmin &&
                        <i className="material-icons" onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }}>settings</i>
                      }
                    </div>
                    <div className="side-view-contact">
                      <img src="images/website_icon.svg" />
                      <span>{profile.website}</span>
                      {profile.isAdmin &&
                        <i className="material-icons" onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }}>settings</i>
                      }
                    </div>
                  </div>
                  <div className="side-view-socials">
                    {
                      profile.socials.map((item, i) => {
                        return (
                          <a key={i}>
                            <img src={item.icon} className="profile_social_icons" />
                          </a>
                        )
                      })
                    }
                    {profile.socials.length === 0 &&
                      <span>Add Social Links</span>
                    }
                    {profile.isAdmin &&
                      <i className="material-icons" onClick={() => {
                        this.setState({
                          activeTab: "Contact & Basic Info"
                        });
                      }}>settings</i>
                    }
                  </div>
                </div>
              </div>
            }

            {(this.state.activeTab === "Contact & Basic Info") &&
              <div className="contact-about">
                <h4>Contact Information</h4>
                <AboutBasicEdit isTeleInput={true} value={profile.contactMain} label="Mobile" type="number" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=league&q=id" field="ContactNumber" fieldId={profile.id} />
                <AboutBasicEdit isTeleInput={true} value={profile.contactOther} label="Other Phone" type="number" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=league&q=id" field="OtherContactNumber" fieldId={profile.id} />
                <AboutSocialEdit profile={profile} type="L" label="Social Links" isAdmin={profile.isAdmin} socials={profile.socials} />
                <AboutBasicEdit isTextInput={true} isWeb={true} value={profile.website} label="Website" isLink="true" href={profile.website} type="website" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=league&q=id" field="Website" fieldId={profile.id} />
                <AboutBasicEdit isTextInput={true} value={profile.email} label="Email" isLink="true" href={"mailto:" + profile.email} type="email" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=league&q=id" field="Email" fieldId={profile.id} />
                
                <AboutBasicEdit isTextInput={true} isUser={true} value={profile.suburb} label="Suburb" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=league&q=id" fieldType={"L"} field={"Suburb"} privacy={""} fieldId={profile.id} />

                      <AboutBasicEdit isRegionPicker={true} mode={"state"} isUser={true} value={profile.state} label="State/Province" type="" isAdmin={profile.isAdmin} fieldType={"L"} field={"State"} country={profile.country} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=league&q=id" />

                      <AboutBasicEdit isTextInput={true} isUser={true} value={profile.postal} label="Postal Code" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=league&q=id" fieldType={"L"} field={"Postal"} privacy={""} fieldId={profile.id} />

                      <AboutBasicEdit isRegionPicker={true} mode={"country"} isUser={true} value={profile.country} label="Country" type="" isAdmin={profile.isAdmin} fieldType={"L"} field={"Country"} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=league&q=id" />
                <h4>Established</h4>
                <AboutBasicEdit isYearPicker={true} isDatePicker={true} value={profile.establishYear} label={"Year"} type="text" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=league&q=id" field={"EstablishYear"} fieldId={profile.id} />
                <AboutBasicEdit isDatePicker={true} value={profile.establishMonth} isYearPicker={false} label={"Date"} type="text" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=league&q=id" field={"EstablishMonth"} fieldId={profile.id} />
                <h4>Background Information</h4>
                <AboutBioEdit privacy={""} fieldType={"L"} value={profile.about} label={""} type="text" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=league&q=id" field={"History"} privacyField={"HistoryPrivacy"} fieldId={profile.id} />
              </div>
            }
            {(this.state.activeTab === "People") &&
              <div className="contact-about">
                <h4>IMPORTANT PEOPLE</h4>
                <AboutLabelEdit title="Manager" isAdmin={profile.isAdmin} value={profile.manager.name} url="/updatePageContacts.php?auth0&ref=league&q=id" field="Manager" fieldId={profile.id} />
                <AboutLabelEdit title="Secretary" isAdmin={profile.isAdmin} value={profile.secretary.name} url="/updatePageContacts.php?auth0&ref=league&q=id" field="Secretary" fieldId={profile.id} />
                <h4>OTHER PEOPLE</h4>
                {
                  profile.roles.map((item, i) => {
                    return (
                      <AboutClubRoleEdit roles={["Admin Secretary", "Captain", "Chairman", "CFO", "CEO", "Coach", "COO","Editor", "Managing Director", "Player", "Referee", "Receptionist ", "Score Keeper", "Staff Admin"]} title={item.role} isAdmin={profile.isAdmin} item={item} key={item.id} />
                    )
                  })
                }
                {(this.state.isAddingRole && profile.isAdmin) &&
                  <AboutClubRoleEdit toId={profile.id} onAddCallBack={() => this.setState({ isAddingRole: false })} toType={"L"} isNew={true} roles={["Admin Secretary", "Captain", "Chairman", "CFO", "CEO", "Coach", "COO","Editor", "Managing Director", "Player", "Referee", "Receptionist ", "Score Keeper", "Staff Admin"]} title={"Add New Role"} isAdmin={profile.isAdmin} key={"new"} />
                }
                {(!this.state.isAddingRole && profile.isAdmin) &&
                  <span className="add-about" onClick={() => this.setState({ isAddingRole: true })}>+ Add Role</span>
                }
              </div>
            }
          </EventViewSplitPane>
        }
        {(!this.props.hideTabs && this.props.state === "user") &&
          <div className="view-with-tabs">
            <div className="view-with-tabs-head">
              {
                this.state.userTabs.map((item, i) => {
                  return (
                    <div key={i} className={(item === this.state.userActiveTab) ? "view-with-tabs-head-item active" : "view-with-tabs-head-item"} onClick={() => this.setState({ userActiveTab: item })}>{item}</div>
                  )
                })
              }
            </div>
            <div className="view-with-tabs-body">
              {this.state.userActiveTab === "About" &&
                <EventViewSplitPane isExtended="true" active={this.state.activeTab === "Contact & Basic Info" ? "Personal Info" : this.state.activeTab} items={["Overview", "Personal Info", "Work & Education", "Places I've Lived", "Family", "Details About You"]} setView={(d) => {
                  this.setState({
                    activeTab: d
                  });
                }}>
                  {(this.state.activeTab === "Overview") &&
                    <div className="overview-about">
                      <div className="main-view">
                        <AboutLabel title={"Full Name"} isAdmin={profile.isAdmin} value={profile.name} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"D.O.B"} isAdmin={profile.isAdmin} value={profile.dob + " (" + profile.age + ")"} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />



                        <AboutLabel title={"Physical Address"} isAdmin={profile.isAdmin} value={profile.address} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"Suburb"} isAdmin={profile.isAdmin} value={profile.suburb} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"State/Province"} isAdmin={isParent} value={profile.state} onClick={() => {
                          this.setState({
                            activeTab: "Work & Education"
                          });
                        }} />

                        <AboutLabel title={"Postal Code"} isAdmin={profile.isAdmin} value={profile.postal} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"Country"} isAdmin={profile.isAdmin} value={profile.country} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />
                        <AboutLabel title={(Array.isArray(profile.work.current)) ? "Work place not set" : profile.work.current.position + " at " + profile.work.current.name} isAdmin={profile.isAdmin} value={(profile.work.past === null) ? "" : "Past : " + profile.work.past.position + " at " + profile.work.past.name} onClick={() => {
                          this.setState({
                            activeTab: "Work & Education"
                          });
                        }} />
                        <AboutLabel title={(Array.isArray(profile.education.current)) ? "Education not set" : "Studies at " + profile.education.current.name} isAdmin={profile.isAdmin} value={(profile.education.past.length === 0) ? "" : "Past : Studied at " + profile.education.past[0].name} onClick={() => {
                          this.setState({
                            activeTab: "Work & Education"
                          });
                        }} />
                        <AboutLabel title={(profile.placesLived.current.name === "not set") ? "Current place is not set" : "Lives in " + profile.placesLived.current.name} isAdmin={profile.isAdmin} value={(profile.placesLived.home.name === "not set") ? "Hometown is not set" : "From " + profile.placesLived.home.name} onClick={() => {
                          this.setState({
                            activeTab: "Places I've Lived"
                          });
                        }} />
                      </div>
                      <div className="side-view">
                        <div className="side-view-contacts">
                          <div className="side-view-contact">
                            <img src="images/mobile_icon.svg" />
                            <span>{profile.contacts.personal[0].value}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                          <div className="side-view-contact">
                            <img src="images/landline_icon.svg" />
                            <span>{profile.contacts.personal[1].value}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                          <div className="side-view-contact">
                            <img src="images/email_icon.svg" />
                            <span>{profile.contacts.personal[2].value}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                          <div className="side-view-contact">
                            <img src="images/website_icon.svg" />
                            <span>{profile.contacts.personal[3].value}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                        </div>
                        <div className="side-view-socials">
                          {
                            profile.contacts.social.map((item, i) => {
                              return (
                                <a key={i}>
                                  <img src={item.icon} className="profile_social_icons" />
                                </a>
                              )
                            })
                          }
                          {profile.contacts.social.length === 0 &&
                            <span>Add Social Links</span>
                          }
                          {profile.isAdmin &&
                            <i className="material-icons" onClick={() => {
                              this.setState({
                                activeTab: "Contact & Basic Info"
                              });
                            }}>settings</i>
                          }
                        </div>
                      </div>
                    </div>
                  }

                  {(this.state.activeTab === "Personal Info" || this.state.activeTab === "Contact & Basic Info") &&
                    <div className="contact-about">
                      <h4>Personal Information</h4>
                      <AboutBasicEdit isTextInput={true} isUser={true} value={profile.first_name} label="Name" type="" isAdmin={profile.isAdmin} fieldType={"F"} field={"name"} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=users&q=user_id" />
                      <AboutBasicEdit isTextInput={true} isUser={true} value={profile.last_name} label="Surname" type="" isAdmin={profile.isAdmin} fieldType={"F"} field={"surname"} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=users&q=user_id" />


                      <h4>Contact Information</h4>
                      <AboutBasicEdit isTeleInput={true} value={profile.contacts.personal[0].value} label="Mobile" type="number" isAdmin={profile.isAdmin} url="updateMetaData.php?auth0" field={profile.contacts.personal[0].rawKey} privacy={profile.contacts.personal[0].privacy} fieldId={profile.id} />
                      <AboutBasicEdit isTeleInput={true} value={profile.contacts.personal[1].value} label="Telephone" type="number" isAdmin={profile.isAdmin} url="updateMetaData.php?auth0" field={profile.contacts.personal[1].rawKey} privacy={profile.contacts.personal[1].privacy} fieldId={profile.id} />
                      <AboutSocialEdit profile={profile} label="Social Links" isAdmin={profile.isAdmin} type="P" socials={profile.contacts.social} />
                      <AboutBasicEdit isTextInput={true} isWeb={true} value={profile.contacts.personal[3].value} label="Website" isLink="true" href={profile.contacts.personal[3].value} type="website" isAdmin={profile.isAdmin} url="updateMetaData.php?auth0" field={profile.contacts.personal[3].rawKey} privacy={profile.contacts.personal[3].privacy} fieldId={profile.id} />
                      <AboutBasicEdit isTextInput={true} isEmail={true} value={profile.contacts.personal[2].value} label="Email" isLink="true" href={"mailto:" + profile.contacts.personal[2].value} type="email" isAdmin={profile.isAdmin} url="updateMetaData.php?auth0" field={profile.contacts.personal[2].rawKey} privacy={profile.contacts.personal[2].privacy} fieldId={profile.id} />

                      <AboutBasicEdit isTextInput={true} isUser={true} value={profile.address} label="Physical Address" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=users&q=user_id" fieldType={"F"} field={"user_address"} privacy={""} fieldId={profile.id} />

                      <AboutBasicEdit isTextInput={true} isUser={true} value={profile.suburb} label="Suburb" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=users&q=user_id" fieldType={"F"} field={"user_suburb"} privacy={""} fieldId={profile.id} />

                      <AboutBasicEdit isRegionPicker={true} mode={"state"} isUser={true} value={profile.state} label="State/Province" type="" isAdmin={profile.isAdmin} fieldType={"F"} field={"user_state"} country={profile.country} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=users&q=user_id" />

                      <AboutBasicEdit isTextInput={true} isUser={true} value={profile.postal} label="Postal Code" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=users&q=user_id" fieldType={"F"} field={"user_postal"} privacy={""} fieldId={profile.id} />

                      <AboutBasicEdit isRegionPicker={true} mode={"country"} isUser={true} value={profile.country} label="Country" type="" isAdmin={profile.isAdmin} fieldType={"F"} field={"user_country"} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=users&q=user_id" />

                      <h4>Basic Information</h4>
                      {
                        profile.basicInfo.map((item, i) => {
                          return (
                            <AboutBasicEdit privacy={item.privacy} key={i} value={item.value} isComboPicker={(item.rawKey === "user_gender") ? true : false} isWeightHeight={(item.rawKey === "user_height" || item.rawKey === "user_weight") ? true : false} isDatePicker={(item.rawKey === "birth_date" || item.rawKey === "birth_year") ? true : false} isYearPicker={(item.rawKey === "birth_year") ? true : false} label={item.key} type="text" isAdmin={profile.isAdmin} url="updateMetaData.php?auth0" field={item.rawKey} fieldId={profile.id} />
                          )
                        })
                      }

                    </div>
                  }

                  {(this.state.activeTab === "Work & Education") &&
                    <div className="contact-about">
                      <h4>Work</h4>
                      {
                        profile.work.others.map((item, i) => {
                          return (
                            <AboutWorkEdit isNew={true} key={i} class={((profile.work.others.length === (i + 1) && profile.isAdmin) && !this.state.isAddingWork) ? "last" : ""} work={item} isAdmin={profile.isAdmin} onWorkSave={this.onWorkSave.bind(this)} />
                          )
                        })
                      }
                      {
                        this.state.isAddingWork &&
                        <AboutWorkEdit isNew={true} class="last" work={this.state.newWork} isAdmin={profile.isAdmin} onWorkSave={this.onWorkSave.bind(this)} />
                      }
                      {profile.isAdmin &&
                        <span className="add-about" onClick={() => {
                          this.setState({
                            isAddingWork: (this.state.isAddingWork) ? false : true
                          });
                        }}>+ Add Workplace</span>
                      }
                      <h4>College</h4>
                      {
                        profile.education.others.map((item, i) => {
                          if (item.type !== "College") {
                            return null
                          }
                          return (
                            <AboutCollegeEdit isNew={true} label="College" key={i} class={((profile.education.others.length === (i + 1) && profile.isAdmin) && !this.state.isAddingCollege) ? "last" : ""} college={item} isAdmin={profile.isAdmin} onCollgeSave={this.onCollgeSave.bind(this)} />
                          )
                        })
                      }
                      {
                        this.state.isAddingCollege &&
                        <AboutCollegeEdit label="College" isNew={true} class="last" college={this.state.newCollege} isAdmin={profile.isAdmin} onCollgeSave={this.onCollgeSave.bind(this)} />
                      }
                      {profile.isAdmin &&
                        <span className="add-about" onClick={() => {
                          this.setState({
                            isAddingCollege: (this.state.isAddingCollege) ? false : true
                          });
                        }}>+ Add College</span>
                      }
                      <h4>High School</h4>
                      {
                        profile.education.others.map((item, i) => {
                          if (item.type !== "School") {
                            return null
                          }
                          return (
                            <AboutCollegeEdit isNew={true} label="School" key={i} class={((profile.education.others.length === (i + 1) && profile.isAdmin) && !this.state.isAddingSchool) ? "last" : ""} college={item} isAdmin={profile.isAdmin} onCollgeSave={this.onSchoolSave.bind(this)} />
                          )
                        })
                      }
                      {
                        this.state.isAddingSchool &&
                        <AboutCollegeEdit label="School" isNew={true} class="last" college={this.state.newSchool} isAdmin={profile.isAdmin} onCollgeSave={this.onSchoolSave.bind(this)} />
                      }
                      {profile.isAdmin &&
                        <span className="add-about" onClick={() => {
                          this.setState({
                            isAddingSchool: (this.state.isAddingSchool) ? false : true
                          });
                        }}>+ Add High School</span>
                      }
                    </div>
                  }

                  {(this.state.activeTab === "Places I've Lived") &&
                    <div className="contact-about">
                      <h4>Current & Hometown</h4>
                      <AboutHometownEdit isNew={true} class="last" city={profile.placesLived.current} title="Current City" isAdmin={profile.isAdmin} field={profile.placesLived.current.rawKey} fieldId={profile.id} />
                      <AboutHometownEdit isNew={true} city={profile.placesLived.home} title="Home Town" isAdmin={profile.isAdmin} field={profile.placesLived.home.rawKey} fieldId={profile.id} />
                      <h4>Other Places</h4>
                      {
                        profile.placesLived.others.map((item, i) => {
                          return (
                            <AboutCityEdit isNew={true} city={item} key={i} isAdmin={profile.isAdmin} onCitySave={this.onCitySave.bind(this)} />
                          )
                        })
                      }
                      {(this.state.isAddingCity) &&
                        <AboutCityEdit isNew={true} city={{ "name": "", "coord": { "lon": "", "lat": "" } }} isAdmin={profile.isAdmin} onCitySave={this.onCitySave.bind(this)} />
                      }
                      {profile.isAdmin &&
                        <span className="add-about" onClick={() => {
                          this.setState({
                            isAddingCity: (this.state.isAddingCity) ? false : true
                          });
                        }}>+ Add a Place</span>
                      }
                    </div>
                  }

                  {(this.state.activeTab === "Family") &&
                    <div className="family-members">
                      {
                        profile.family.map((item, i) => {
                          return (
                            <FamilyMember key={i} user={item} isAdmin={profile.isAdmin} />
                          )
                        })
                      }
                      {this.state.isAddingMember &&
                        <div className="add-member" style={{ backgroundColor: "#eee", margin: "10px" }}>
                          <div className="add-member-upper">
                            <span>Family Member</span>
                            <div>
                              <UserPicker data={profile.friends} onUserSelect={(user) => {
                                const _that = this
                                _that.state.newMember['user'] = user
                                //_that.setState({newMember:_that.newMember})
                              }} />
                              <select onChange={(e) => {
                                const val = e.target.value;
                                const _that = this
                                _that.state.newMember['tag'] = val
                                //_that.setState({newMember:_that.newMember})
                              }}>
                                <option value={null} disabled>Select Relationship</option>
                                {
                                  this.state.memberTypes.map((item, i) => {
                                    return (
                                      <option key={i} value={item}>{item.capitalize()}</option>
                                    )
                                  })
                                }
                              </select>
                            </div>
                          </div>
                          <div className="add-member-lower">
                            <PublicityPicker onChange={(e) => {
                              const _that = this
                              //console.log(e)
                              _that.state.newMember['privacy'] = e
                              //_that.setState({newMember:_that.newMember});
                            }} />
                            <div onClick={this.addMember.bind(this)}>Save</div>
                            <div onClick={() => {
                              this.setState({ isAddingMember: (this.state.isAddingMember) ? false : true });
                            }}>Cancel</div>
                          </div>
                        </div>
                      }
                      {profile.isAdmin &&
                        <div className="family-member" onClick={() => {
                          this.setState({ isAddingMember: (this.state.isAddingMember) ? false : true });
                        }}>
                          <div className="family-member-user" tabIndex="0">
                            <img src="images/add_friend.svg" />
                            <div>
                              <span>Add Member</span>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }

                  {(this.state.activeTab === "Details About You") &&
                    <div className="contact-about">
                      <h4>About</h4>
                      <AboutBioEdit fieldType={"F"} privacy={profile.aboutPrivacy} value={profile.about} label={""} type="text" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=users&q=user_id" field={"about_user"} privacyField={"about_privacy"} fieldId={profile.id} />
                      {profile.isAdmin && <h4>Emergency Information</h4>}
                      {profile.isAdmin && <AdditionalInformation key={"e"} type={"F"} isMedical={false} profile={profile} isAdmin={profile.isAdmin} />}
                      {profile.isAdmin && <h4>Medical Information</h4>}
                      {profile.isAdmin && <AdditionalInformation key={"e"} type={"F"} isMedical={true} profile={profile} isAdmin={profile.isAdmin} />}
                    </div>
                  }
                </EventViewSplitPane>
              }
              {this.state.userActiveTab === "Sports" &&
                <EventViewSplitPane isExtended="true" active={this.state.activeSportTab} items={["Sports I Play", "Sports I Folow"]} setView={(d) => {
                  this.setState({
                    activeSportTab: d
                  });
                }}>
                  {(this.state.activeSportTab === "Sports I Play") &&
                    <SportPlayedView profile={profile} sports={profile.mySport} isAdmin={profile.isAdmin} teams={profile.myTeams} />
                  }
                  {(this.state.activeSportTab === "Sports I Folow") &&
                    <UserSportsList id={profile.id} sports={profile.sportsFollowed} isAdmin={profile.isAdmin} category="following" />
                  }
                </EventViewSplitPane>
              }
              {this.state.userActiveTab === "Teams" &&
                <EventViewSplitPane isExtended="true" active={this.state.activeTeamTab} items={["My Teams", "Teams I Folow"]} setView={(d) => {
                  this.setState({
                    activeTeamTab: d
                  });
                }}>
                  {(this.state.activeTeamTab === "My Teams") &&
                    <UserTeamsList user={profile} sports={profile.mySport} teams={profile.myTeams} isAdmin={profile.isAdmin} category="mine" />
                  }
                  {(this.state.activeTeamTab === "Teams I Folow") &&
                    <UserTeamsList user={profile} sports={profile.sportsFollowed} teams={profile.teamsFollowed} isAdmin={profile.isAdmin} category="following" />
                  }
                </EventViewSplitPane>
              }
            </div>
          </div>
        }
        {(!this.props.hideTabs && this.props.state === "club") &&
          <div className="view-with-tabs">
            <div className="view-with-tabs-head">
              {
                this.state.userTabs.map((item, i) => {
                  if (item === "Teams") {
                    return null;
                  }
                  return (
                    <div key={i} className={(item === this.state.clubActiveTab) ? "view-with-tabs-head-item active" : "view-with-tabs-head-item"} onClick={() => this.setState({ clubActiveTab: item })}>{item}</div>
                  )
                })
              }
            </div>
            <div className="view-with-tabs-body">
              {this.state.clubActiveTab === "About" &&
                <EventViewSplitPane isExtended="true" active={this.state.activeTab} items={["Overview", "Contact & Basic Info", "People"]} setView={(d) => {
                  this.setState({
                    activeTab: d
                  });
                }}>
                  {(this.state.activeTab === "Overview") &&
                    <div className="overview-about">
                      <div className="main-view">
                        <AboutLabel title="Manager" isAdmin={profile.isAdmin} value={profile.manager.name} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />
                        <AboutLabel title="Secretary" isAdmin={profile.isAdmin} value={profile.secretary.name} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />
                        <AboutLabel title="Founded" isAdmin={profile.isAdmin} value={profile.establishMonth + ', ' + profile.establishYear} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />
                        <AboutLabel title={"Physical Address"} isAdmin={profile.isAdmin} value={profile.address} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"Suburb"} isAdmin={profile.isAdmin} value={profile.suburb} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"State/Province"} isAdmin={profile.isAdmin} value={profile.state} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"Postal Code"} isAdmin={profile.isAdmin} value={profile.postal} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"Country"} isAdmin={profile.isAdmin} value={profile.country} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />
                        <AboutLabel title="Background Information" isRichText={true} isAdmin={profile.isAdmin} value={profile.about} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />
                      </div>
                      <div className="side-view">
                        <div className="side-view-contacts">
                          <div className="side-view-contact">
                            <img src="images/mobile_icon.svg" />
                            <span>{profile.contactMain}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                          <div className="side-view-contact">
                            <img src="images/landline_icon.svg" />
                            <span>{profile.contactOther}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                          <div className="side-view-contact">
                            <img src="images/email_icon.svg" />
                            <span>{profile.email}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                          <div className="side-view-contact">
                            <img src="images/website_icon.svg" />
                            <span>{profile.website}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                        </div>
                        <div className="side-view-socials">
                          {
                            profile.socials.map((item, i) => {
                              return (
                                <a key={i}>
                                  <img src={item.icon} className="profile_social_icons" />
                                </a>
                              )
                            })
                          }
                          {profile.socials.length === 0 &&
                            <span>Add Social Links</span>
                          }
                          {profile.isAdmin &&
                            <i className="material-icons" onClick={() => {
                              this.setState({
                                activeTab: "Contact & Basic Info"
                              });
                            }}>settings</i>
                          }
                        </div>
                      </div>
                    </div>
                  }

                  {(this.state.activeTab === "Contact & Basic Info") &&
                    <div className="contact-about">
                      <h4>Contact Information</h4>
                      <AboutBasicEdit isTeleInput={true} value={profile.contactMain} label="Mobile" type="number" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=clubs&q=ClubID" field="ContactNumber" fieldId={profile.id} />
                      <AboutBasicEdit isTeleInput={true} value={profile.contactOther} label="Other Phone" type="number" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=clubs&q=ClubID" field="OtherContactNumber" fieldId={profile.id} />
                      <AboutSocialEdit profile={profile} type="C" label="Social Links" isAdmin={profile.isAdmin} socials={profile.socials} />
                      <AboutBasicEdit isTextInput={true} isWeb={true} value={profile.website} label="Website" isLink="true" href={profile.website} type="website" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=clubs&q=ClubID" field="Website" fieldId={profile.id} />
                      <AboutBasicEdit isTextInput={true} isEmail={true} value={profile.email} label="Email" isLink="true" href={"mailto:" + profile.email} type="email" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=clubs&q=ClubID" field="Email" fieldId={profile.id} />
                      
                      <AboutBasicEdit isTextInput={true} isUser={true} value={profile.suburb} label="Suburb" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=clubs&q=ClubID" fieldType={"C"} field={"Suburb"} privacy={""} fieldId={profile.id} />

                      <AboutBasicEdit isRegionPicker={true} mode={"state"} isUser={true} value={profile.state} label="State/Province" type="" isAdmin={profile.isAdmin} fieldType={"C"} field={"State"} country={profile.country} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=clubs&q=ClubID" />

                      <AboutBasicEdit isTextInput={true} isUser={true} value={profile.postal} label="Postal Code" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=clubs&q=ClubID" fieldType={"C"} field={"PostalCode"} privacy={""} fieldId={profile.id} />

                      <AboutBasicEdit isRegionPicker={true} mode={"country"} isUser={true} value={profile.country} label="Country" type="" isAdmin={profile.isAdmin} fieldType={"C"} field={"Country"} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=clubs&q=ClubID" />
                      <h4>Established</h4>
                      <AboutBasicEdit isYearPicker={true} isDatePicker={true} value={profile.establishYear} label={"Year"} type="text" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=clubs&q=ClubID" field={"EstablishYear"} fieldId={profile.id} />
                      <AboutBasicEdit isDatePicker={true} value={profile.establishMonth} isYearPicker={false} label={"Date"} type="text" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=clubs&q=ClubID" field={"EstablishMonth"} fieldId={profile.id} />
                      <h4>Background Information</h4>
                      <AboutBioEdit privacy={""} fieldType={"C"} value={profile.about} label={""} type="text" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=clubs&q=ClubID" field={"History"} privacyField={"HistoryPrivacy"} fieldId={profile.id} />
                    </div>
                  }
                  {(this.state.activeTab === "People") &&
                    <div className="contact-about">
                      <h4>IMPORTANT PEOPLE</h4>
                      <AboutLabelEdit title="Club Manager" isAdmin={profile.isAdmin} value={profile.manager.name} url="/updatePageContacts.php?auth0&ref=clubs&q=ClubID" field="Manager" fieldId={profile.id} />
                      <AboutLabelEdit title="Club Secretary" isAdmin={profile.isAdmin} value={profile.secretary.name} url="/updatePageContacts.php?auth0&ref=clubs&q=ClubID" field="Secretary" fieldId={profile.id} />
                      <h4>OTHER PEOPLE</h4>
                      {
                        profile.roles.map((item, i) => {
                          return (
                            <AboutClubRoleEdit roles={["Admin Secretary", "Captain", "Chairman", "CFO", "CEO", "Coach", "COO","Editor", "Managing Director", "Player", "Referee", "Receptionist ", "Score Keeper", "Staff Admin"]} title={item.role} isAdmin={profile.isAdmin} item={item} key={item.id} />
                          )
                        })
                      }
                      {(this.state.isAddingRole && profile.isAdmin) &&
                        <AboutClubRoleEdit toId={profile.id} onAddCallBack={() => this.setState({ isAddingRole: false })} toType={"C"} isNew={true} roles={["Admin Secretary", "Captain", "Chairman", "CFO", "CEO", "Coach", "COO","Editor", "Managing Director", "Player", "Referee", "Receptionist ", "Score Keeper", "Staff Admin"]} title={"Add New Role"} isAdmin={profile.isAdmin} key={"new"} />
                      }
                      {(!this.state.isAddingRole && profile.isAdmin) &&
                        <span className="add-about" onClick={() => this.setState({ isAddingRole: true })}>+ Add Role</span>
                      }
                    </div>
                  }
                </EventViewSplitPane>
              }
              {this.state.clubActiveTab === "Sports" &&
                <div style={{ padding: "20px" }}>
                  <ClubSportsList id={profile.id} type={"C"} sports={profile.sports} isAdmin={profile.isAdmin} category="following" />
                </div>
              }
            </div>
          </div>
        }
        {(!this.props.hideTabs && this.props.state === "institution") &&
          <div className="view-with-tabs">
            <div className="view-with-tabs-head">
              {
                this.state.userTabs.map((item, i) => {
                  if (item === "Teams") {
                    return null;
                  }
                  return (
                    <div key={i} className={(item === this.state.clubActiveTab) ? "view-with-tabs-head-item active" : "view-with-tabs-head-item"} onClick={() => this.setState({ clubActiveTab: item })}>{item}</div>
                  )
                })
              }
            </div>
            <div className="view-with-tabs-body">
              {this.state.clubActiveTab === "About" &&
                <EventViewSplitPane isExtended="true" active={this.state.activeTab} items={["Overview", "Contact & Basic Info", "People"]} setView={(d) => {
                  this.setState({
                    activeTab: d
                  });
                }}>
                  {(this.state.activeTab === "Overview") &&
                    <div className="overview-about">
                      <div className="main-view">
                        <AboutLabel title="Manager" isAdmin={profile.isAdmin} value={profile.manager.name} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />
                        <AboutLabel title="Secretary" isAdmin={profile.isAdmin} value={profile.secretary.name} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />
                        <AboutLabel title="Founded" isAdmin={profile.isAdmin} value={profile.establishMonth + ', ' + profile.establishYear} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />
                        <AboutLabel title={"Physical Address"} isAdmin={profile.isAdmin} value={profile.address} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"Suburb"} isAdmin={profile.isAdmin} value={profile.suburb} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"State/Province"} isAdmin={profile.isAdmin} value={profile.state} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"Postal Code"} isAdmin={profile.isAdmin} value={profile.postal} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />

                        <AboutLabel title={"Country"} isAdmin={profile.isAdmin} value={profile.country} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />
                        <AboutLabel title="Background Information" isRichText={true} isAdmin={profile.isAdmin} value={profile.about} onClick={() => {
                          this.setState({
                            activeTab: "Contact & Basic Info"
                          });
                        }} />
                      </div>
                      <div className="side-view">
                        <div className="side-view-contacts">
                          <div className="side-view-contact">
                            <img src="images/mobile_icon.svg" />
                            <span>{profile.contactMain}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                          <div className="side-view-contact">
                            <img src="images/landline_icon.svg" />
                            <span>{profile.contactOther}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                          <div className="side-view-contact">
                            <img src="images/email_icon.svg" />
                            <span>{profile.email}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                          <div className="side-view-contact">
                            <img src="images/website_icon.svg" />
                            <span>{profile.website}</span>
                            {profile.isAdmin &&
                              <i className="material-icons" onClick={() => {
                                this.setState({
                                  activeTab: "Contact & Basic Info"
                                });
                              }}>settings</i>
                            }
                          </div>
                        </div>
                        <div className="side-view-socials">
                          {
                            profile.socials.map((item, i) => {
                              return (
                                <a key={i}>
                                  <img src={item.icon} className="profile_social_icons" />
                                </a>
                              )
                            })
                          }
                          {profile.socials.length === 0 &&
                            <span>Add Social Links</span>
                          }
                          {profile.isAdmin &&
                            <i className="material-icons" onClick={() => {
                              this.setState({
                                activeTab: "Contact & Basic Info"
                              });
                            }}>settings</i>
                          }
                        </div>
                      </div>
                    </div>
                  }

                  {(this.state.activeTab === "Contact & Basic Info") &&
                    <div className="contact-about">
                      <h4>Contact Information</h4>
                      <AboutBasicEdit isTeleInput={true} value={profile.contactMain} label="Mobile" type="number" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=institution&q=InstitutionID" field="ContactNumber" fieldId={profile.id} />
                      <AboutBasicEdit isTeleInput={true} value={profile.contactOther} label="Other Phone" type="number" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=institution&q=InstitutionID" field="OtherContactNumber" fieldId={profile.id} />
                      <AboutSocialEdit profile={profile} type="I" label="Social Links" isAdmin={profile.isAdmin} socials={profile.socials} />
                      <AboutBasicEdit isTextInput={true} isWeb={true} value={profile.website} label="Website" isLink="true" href={profile.website} type="website" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=institution&q=InstitutionID" field="Website" fieldId={profile.id} />
                      <AboutBasicEdit isTextInput={true} isEmail={true} value={profile.email} label="Email" isLink="true" href={"mailto:" + profile.email} type="email" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=institution&q=InstitutionID" field="Email" fieldId={profile.id} />
                      
                      <AboutBasicEdit isTextInput={true} isUser={true} value={profile.suburb} label="Suburb" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=institution&q=InstitutionID" fieldType={"I"} field={"Suburb"} privacy={""} fieldId={profile.id} />

                      <AboutBasicEdit isRegionPicker={true} mode={"state"} isUser={true} value={profile.state} label="State/Province" type="" isAdmin={profile.isAdmin} fieldType={"I"} field={"State"} country={profile.country} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=institution&q=InstitutionID" />

                      <AboutBasicEdit isTextInput={true} isUser={true} value={profile.postal} label="Postal Code" type="" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=institution&q=InstitutionID" fieldType={"I"} field={"PostalCode"} privacy={""} fieldId={profile.id} />

                      <AboutBasicEdit isRegionPicker={true} mode={"country"} isUser={true} value={profile.country} label="Country" type="" isAdmin={profile.isAdmin} fieldType={"I"} field={"Country"} privacy={""} fieldId={profile.id} url="updateAboutData.php?auth0&ref=institution&q=InstitutionID" />
                      <h4>Established</h4>
                      <AboutBasicEdit isYearPicker={true} isDatePicker={true} value={profile.establishYear} label={"Year"} type="text" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=institution&q=InstitutionID" field={"EstablishYear"} fieldId={profile.id} />
                      <AboutBasicEdit isDatePicker={true} value={profile.establishMonth} isYearPicker={false} label={"Date"} type="text" isAdmin={profile.isAdmin} url="/updatePageContacts.php?auth0&ref=institutions&q=ClubID" field={"EstablishMonth"} fieldId={profile.id} />
                      <h4>Background Information</h4>
                      <AboutBioEdit privacy={""} fieldType={"C"} value={profile.about} label={""} type="text" isAdmin={profile.isAdmin} url="updateAboutData.php?auth0&ref=institutions&q=ClubID" field={"History"} privacyField={"HistoryPrivacy"} fieldId={profile.id} />
                    </div>
                  }
                  {(this.state.activeTab === "People") &&
                    <div className="contact-about">
                      <h4>IMPORTANT PEOPLE</h4>
                      <AboutLabelEdit title="Club Manager" isAdmin={profile.isAdmin} value={profile.manager.name} url="/updatePageContacts.php?auth0&ref=institution&q=InstitutionID" field="Manager" fieldId={profile.id} />
                      <AboutLabelEdit title="Club Secretary" isAdmin={profile.isAdmin} value={profile.secretary.name} url="/updatePageContacts.php?auth0&ref=institution&q=InstitutionID" field="Secretary" fieldId={profile.id} />
                      <h4>OTHER PEOPLE</h4>
                      {
                        profile.roles.map((item, i) => {
                          return (
                            <AboutClubRoleEdit roles={["Admin Secretary", "Captain", "Chairman", "CFO", "CEO", "Coach", "COO","Editor", "Managing Director", "Player", "Referee", "Receptionist ", "Score Keeper", "Staff Admin"]} title={item.role} isAdmin={profile.isAdmin} item={item} key={item.id} />
                          )
                        })
                      }
                      {(this.state.isAddingRole && profile.isAdmin) &&
                        <AboutClubRoleEdit toId={profile.id} onAddCallBack={() => this.setState({ isAddingRole: false })} toType={"I"} isNew={true} roles={["Admin Secretary", "Captain", "Chairman", "CFO", "CEO", "Coach", "COO","Editor", "Managing Director", "Player", "Referee", "Receptionist ", "Score Keeper", "Staff Admin"]} title={"Add New Role"} isAdmin={profile.isAdmin} key={"new"} />
                      }
                      {(!this.state.isAddingRole && profile.isAdmin) &&
                        <span className="add-about" onClick={() => this.setState({ isAddingRole: true })}>+ Add Role</span>
                      }
                    </div>
                  }
                </EventViewSplitPane>
              }
              {this.state.clubActiveTab === "Sports" &&
                <div style={{ padding: "20px" }}>
                  <ClubSportsList id={profile.id} type={"I"} sports={profile.sports} isAdmin={profile.isAdmin} category="following" />
                </div>
              }
            </div>
          </div>
        }
      </div>
    );
  }
}

class AboutClubRoleEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditting: false,
      error: false,
      user: (this.props.isNew) ? { id: null, name: "" } : this.props.item.user,
      role: (this.props.isNew) ? "" : this.props.title,
      error: {
        user: false,
        role: false
      }
    }
  }

  addRole() {
    const _that = this
    const { error, user, role } = this.state
    const { item } = this.props
    const dataTo = {
      role: role,
      userId: user.id,
      toId: this.props.toId,
      toType: this.props.toType
    }

    if (user.id === null) {
      error.user = true
      this.setState({ error });
      return;
    }

    if (role === null || role === "") {
      error.role = true
      this.setState({ error });
      return;
    }

    FakeData.post("/addRole.php?auth0", dataTo, {
      success(res) {
        _that.props.onAddCallBack()
      },
      error(err) {

      }
    }, true, "Role was added!", (e) => { })
  }

  onSave() {
    const _that = this
    const { error, user, role } = this.state
    const { item } = this.props
    const dataTo = {
      id: item.id,
      role: role,
      userId: user.id,
      u: {
        id: FakeData.getData("yoo").id,
        type: "F"
      }
    }

    if (user.id === null) {
      error.user = true
      this.setState({ error });
      return;
    }

    if (role === null || role === "") {
      error.role = true
      this.setState({ error });
      return;
    }

    FakeData.post("/updateRole.php?auth0", dataTo, {
      success: ((res) => {
        _that.state = {
          isEditting: false
        }
      }),
      error: ((err) => {

      })
    }, true, "Data Saved!", ((res) => {

    }))
  }

  onDelete(id) {
    const _that = this
    const dataTo = {
      id: id,
    }
    FakeData.post("/removeRole.php?auth0", dataTo, {
      success: ((res) => {
        _that.state = {
          isEditting: false
        }
      }),
      error: ((err) => {

      })
    }, true, "Role Removed!", ((res) => {

    }))
  }

  render() {
    const { isEditting, error, user, role } = this.state
    const { item, toType } = this.props;
    const roles = (Roles[toType])?Roles[toType]:[];
    if (this.props.isNew) {
      return (
        <div className="about-label">
          <h2>{this.props.title}</h2>
          <p>{user.name}</p>
          {this.props.isAdmin &&
            <i className="material-icons" style={{ top: 0 }} onClick={() => this.setState({ isEditting: (isEditting) ? false : true })}>edit</i>
          }
          {(this.props.isAdmin) &&
            <div className="about-role-edit">
              <ItemPicker label={"Name"} value={user.name} user={FakeData.getData("yoo")} error={error.user} onSelectedItem={(user) => {
                user = user;
                error.user = false
                this.setState({ user, error });
              }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
              <div className="input-field">
                <span>Role</span>
                <select value={role} className={(error.role) ? "normal-input error" : "normal-input"} onChange={(e) => {
                  error.role = false
                  this.setState({ role: e.target.value, error });
                }}>
                  <option value="">Select role</option>
                  {
                    roles.map((item, i) => {
                      return (
                        <option key={i} value={item}>{item}</option>
                      )
                    })
                  }
                </select>
              </div>
              <button onClick={this.addRole.bind(this)}>Save</button>
            </div>
          }
        </div >
      )
    }
    return (
      <div className="about-label">
        <h2>{this.props.title}</h2>
        <p>{item.user.name}</p>
        {this.props.isAdmin &&
          <i className="material-icons" style={{ top: 0 }} onClick={() => this.setState({ isEditting: (isEditting) ? false : true })}>edit</i>
        }
        {this.props.isAdmin &&
          <i className="material-icons" onClick={() => this.setState({ isDeleting: true })}>delete</i>
        }
        {(this.props.isAdmin && isEditting) &&
          <div className="about-role-edit">
            <ItemPicker label={"Name"} value={user.name} user={FakeData.getData("yoo")} error={error.user} onSelectedItem={(user) => {
              user = user;
              error.user = false
              this.setState({ user, error });
            }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
            <div className="input-field">
              <span>Role</span>
              <select value={role} className={(error.role) ? "normal-input error" : "normal-input"} onChange={(e) => {
                error.role = false
                this.setState({ role: e.target.value, error });
              }}>
                <option value="">Select role</option>
                {
                  roles.map((item, i) => {
                    return (
                      <option key={i} value={item}>{item}</option>
                    )
                  })
                }
              </select>
            </div>
            <button onClick={this.onSave.bind(this)}>Change</button>
          </div>
        }
        {this.state.isDeleting &&
          <ConfirmModal message="Are you sure you want to remove this role?<br/>" isOpen={this.state.isDeleting}
            data={item.id}
            onOkay={(data) => {
              this.onDelete(data)
            }}
            onCancel={() => {
              this.setState({
                isDeleting: false
              })
            }} />
        }
      </div >
    );
  }
}

class AboutLabelEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditting: false,
      error: false,
      user: { id: null, name: "" }
    }
  }

  onSave() {
    const _that = this
    const dataTo = {
      id: this.props.fieldId,
      field: this.props.field,
      value: this.state.user.id
    }

    if (this.state.user.id === null) {
      this.setState({ error: true });
      return;
    }

    const url = this.props.url
    FakeData.post("/" + url, dataTo, {
      success: ((res) => {
        _that.state = {
          isEditting: false
        }
      }),
      error: ((err) => {

      })
    }, true, "Data Saved!", ((res) => {

    }))
  }

  render() {
    const { isEditting, error, user } = this.state
    return (
      <div className="about-label">
        <h2>{this.props.title}</h2>
        <p>{this.props.value}</p>
        {this.props.isAdmin &&
          <i className="material-icons" style={{ top: 0 }} onClick={() => this.setState({ isEditting: (isEditting) ? false : true })}>edit</i>
        }
        {(this.props.isAdmin && isEditting) &&
          <div className="about-label-edit">
            <ItemPicker value={user.name} user={FakeData.getData("yoo")} error={error} onSelectedItem={(user) => {
              user = user;
              this.setState({ user, error: false });
            }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
            <button onClick={this.onSave.bind(this)}>Change</button>
          </div>
        }
      </div >
    );
  }
}

class AboutLabel extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="about-label">
        <h2>{this.props.title}</h2>
        {!this.props.isRichText && <p>{this.props.value}</p>}
        {this.props.isRichText &&
          <RichTextEditor content={this.props.value} isViewing={true} />
        }
        {this.props.isAdmin &&
          <i className="material-icons" onClick={this.props.onClick}>settings</i>
        }
      </div>
    );
  }
}

class AboutBasicEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditting: false,
      value: this.props.value,
      privacy: this.props.privacy,
      isErr: false
    }

    this.onChange = this.onChange.bind(this)
    this.onSave = this.onSave.bind(this)
  }

  onChange(e) {
    this.setState({
      value: e.target.value
    });
  }

  onChangeDate(e) {
    this.setState({
      value: e
    });
  }

  onSave() {
    const _that = this
    const dataTo = this.props.isUser ? {
      id: this.props.fieldId,
      field: this.props.field,
      value: this.state.value,
      privacy: false,
      privacyField: null,
      user: { id: FakeData.getData("yoo").id, type: "F" },
      userTo: { id: this.props.fieldId, type: this.props.fieldType }
    } : {
        id: this.props.fieldId,
        field: this.props.field,
        value: this.state.value,
        privacy: this.state.privacy
      }

    if (this.state.isErr) {
      return;
    }

    const url = this.props.url
    FakeData.post("/" + url, dataTo, {
      success: ((res) => {
        _that.state = {
          isEditting: false
        }
      }),
      error: ((err) => {

      })
    }, true, "Data Saved!", ((res) => {

    }))
  }

  render() {
    return (
      <div className="about-basic-edit">
        <span><strong>{this.props.label} :</strong></span>
        <div className="about-basic-edit-form">
          {!this.props.isLink &&
            <span>{this.props.value}</span>
          }

          {this.props.isLink &&
            <span><a href={this.props.href}><strong>{this.props.value}</strong></a></span>
          }
          {(this.props.isAdmin && this.state.isEditting && this.props.isComboPicker) &&
            <ComboBox placeholder={this.state.value} onSelectedItem={(item) => this.setState({ value: item })} data={["male", "female"]} />
          }
          {(this.props.isAdmin && this.state.isEditting && this.props.isTextInput) &&
            <input className={(this.state.isErr) ? "error" : ""} value={this.state.value} onChange={(e) => {
              const val = e.target.value;
              if (this.props.isWeb) {
                this.setState({ value: val, isErr: !FakeData.isWebsite(val) });
              } else if (this.props.isMail) {
                this.setState({ value: val, isErr: !FakeData.isEmail(val) });
              } else {
                this.setState({ value: val, isErr: false });
              }
            }} />
          }
          {(this.props.isAdmin && this.state.isEditting && this.props.isRegionPicker && this.props.mode === "country") &&
            <CountryDropdown classes={(this.state.isEr) ? "error" : ""}
              value={this.state.value}
              onChange={(val) => {
                this.setState({ value: val, isEr: false });
              }} />
          }
          {(this.props.isAdmin && this.state.isEditting && this.props.isRegionPicker && this.props.mode === "state") &&
            <RegionDropdown classes={(this.state.stateErr) ? "error" : ""}
              country={this.props.country}
              value={this.state.value}

              onChange={(val) => {
                this.setState({ value: val, isEr: false });
              }} />
          }
          {(this.props.isAdmin && this.state.isEditting && this.props.isTeleInput) &&
            <PhonePicker value={this.state.value} onChange={(num, err) => {
              this.setState({ value: num, isErr: err });
            }} />
          }
          {(this.props.isAdmin && this.state.isEditting && this.props.isNativeSelect) &&
            <select value={this.state.value} onChange={(e) => {
              const val = e.target.value;
              this.setState({ value: val, isErr: false });
            }} >
              <option value="">Select...</option>
              {
                FakeData.listify(this.props.selectData).map((item, i) => {
                  return (
                    <option value={item}>{item}</option>
                  )
                })
              }
            </select>
          }
          {(this.props.isAdmin && this.state.isEditting && this.props.isWeightHeight) &&
            <WeightHeightPicker type={this.props.field.replace("user_", "")} onChange={(val) => {
              this.setState({ value: val });
            }} />
          }
          {(this.props.isAdmin && this.state.isEditting && this.props.isDatePicker && this.props.isYearPicker) &&
            <DatePicker withYear={true} onChangeDate={this.onChangeDate.bind(this)} />
          }
          {(this.props.isAdmin && this.state.isEditting && this.props.isDatePicker && !this.props.isYearPicker) &&
            <DatePicker withDay={true} withMonth={true} onChangeDate={this.onChangeDate.bind(this)} />
          }
          {(this.props.isAdmin && this.state.isEditting && this.props.isWeightHeight) &&
            <PublicityPicker onChange={(e) => {
              this.setState({ privacy: e });
            }} />
          }
          <br />
          {(this.props.isAdmin && this.state.isEditting) &&
            <button onClick={this.onSave}>Change</button>
          }
        </div>
        {(this.props.isAdmin) &&
          <i className="material-icons" onClick={() => {
            this.setState({
              isEditting: (this.state.isEditting) ? false : true
            });
          }}>edit</i>
        }
      </div>
    );
  }
}

class AboutBioEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditting: false,
      value: this.props.value,
      privacy: this.props.privacy
    }

    this.onChange = this.onChange.bind(this)
    this.onSave = this.onSave.bind(this)
  }

  onChange(e) {
    this.setState({
      value: e.target.value
    });
  }

  onChangeDate(e) {
    this.setState({
      value: e
    });
  }

  onSave(d) {
    const _that = this
    const dataTo = {
      id: this.props.fieldId,
      field: this.props.field,
      value: d,
      privacy: this.state.privacy,
      privacyField: this.props.privacyField,
      user: { id: FakeData.getData("yoo").id, type: "F" },
      userTo: { id: this.props.fieldId, type: this.props.fieldType }
    }

    const url = this.props.url
    FakeData.post("/" + url, dataTo, {
      success: ((res) => {
        _that.state = {
          isEditting: false
        }
      }),
      error: ((err) => {

      })
    }, true, "Data Saved!", ((res) => {

    }))
  }

  render() {
    return (
      <div className="about-basic-edit">
        <div className="about-basic-edit-form" style={{ padding: "0px 0px!important" }}>
          {(!this.state.isEditting) &&
            <RichTextEditor content={this.props.value} isViewing={true} />
          }
          {(this.props.isAdmin && this.state.isEditting) &&
            <RichTextEditor pictures={(FakeData.getData("user_photos")) ? FakeData.getData("user_photos") : []} content={this.props.value} isBasic={true} onSave={(data) => {
              //console.log(data)
              //this.setState({value:data})
              this.onSave(data)
            }} />
          }

          {(this.props.isAdmin && this.state.isEditting) &&
            <PublicityPicker onChange={(e) => {
              this.setState({ privacy: e });
            }} />
          }
          <br />
          {(this.props.isAdmsin && this.state.isEditting) &&
            <button className="edit-about-btn" onClick={this.onSave}>Change</button>
          }
        </div>
        {(this.props.isAdmin) &&
          <i className="material-icons" style={{ position: "absolute", right: 0, marginTop: "-20px" }} onClick={() => {
            this.setState({
              isEditting: (this.state.isEditting) ? false : true
            });
          }}>edit</i>
        }
      </div>
    );
  }
}

class AboutSocialEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditting: false,
      value: this.props.value,
      newSocial: {
        key: "",
        value: ""
      }
    }

    this.onChange = this.onChange.bind(this)
    this.onSave = this.onSave.bind(this)
  }

  onSave(item) {

  }

  onChange(e) {

  }

  render() {
    return (
      <div className="about-social-edit">
        <span><strong>{this.props.label} :</strong></span>
        {
          <div className="about-social-edit-form">
            <span><a href=""><strong>{(this.props.socials.length === 0) ? "No social links" : this.props.socials[0].value}</strong></a></span>
            {(this.props.isAdmin && this.state.isEditting) &&
              this.props.socials.map((item, i) => {
                return (
                  <SocialEditItem type={this.props.type} data={item} key={item.id} profile={this.props.profile} />
                )
              })
            }
            {(this.props.isAdmin && this.state.isAddingSocial && this.state.isEditting) &&
              <SocialEditItem type={this.props.type} key={"new"} data={this.state.newSocial} onAddCallBack={() => {
                this.setState({
                  isAddingSocial: false, newSocial: {
                    key: "",
                    value: ""
                  }
                });
              }} profile={this.props.profile} />
            }
            {(this.props.isAdmin && this.state.isEditting) &&
              <a className="float-right" style={{ cursor: "pointer" }} onClick={() => {
                this.setState({
                  isAddingSocial: (this.state.isAddingSocial) ? false : true
                });
              }}><strong>+ Add {(this.props.socials.length === 0) ? "a " : "another "}social link</strong></a>
            }
          </div>
        }
        {(this.props.isAdmin) &&
          <i className="material-icons" onClick={() => {
            this.setState({
              isEditting: (this.state.isEditting) ? false : true
            });
          }}>edit</i>
        }
      </div>
    );
  }
}

class SocialEditItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.data.value,
      key: this.props.data.key
    }
  }

  save() {
    const _that = this;
    const _data = this.props.data
    _data.key = this.state.key
    _data.value = this.state.value
    const dataTo = {
      user: this.props.profile,
      type: this.props.type,
      data: _data,
      userTo: {
        id: this.props.profile.id,
        type: this.props.type
      },
      u: {
        id: FakeData.getData("yoo").id,
        type: "F"
      }
    }

    FakeData.post("/addSocial.php?auth0", dataTo, {
      success: ((res) => {
        //console.log(res, dataTo)
        if (_that.props.onAddCallBack) {
          _that.props.onAddCallBack.call(this)
        }
      }),
      error: ((err) => {

      })
    }, true, "Data Saved!", ((e) => {

    }))
  }

  remove() {
    const _that = this
    const dataTo = {
      id: this.props.data.id
    }

    FakeData.post("/deleteSocial.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({ isDeleting: false });
      }),
      error: ((err) => {

      })
    }, true, "Data Removed!", ((res) => { }))
  }

  render() {
    return (
      <div className="about-social-edit-form-input">
        <div className="input-of">
          <input value={this.state.value} onChange={(e) => {
            this.setState({
              value: e.target.value
            });
          }} />
          <select value={this.state.key} onChange={(e) => {
            this.setState({
              key: e.target.value
            });
          }}>
            <option value="">Select Network</option>
            <option value="Facebook">Facebook</option>
            <option value="Google +">Google +</option>
            <option value="Instagram">Instagram</option>
            <option value="Twitter">Twitter</option>
          </select>
        </div>
        <div className="buttons-of">
          <button disabled={(this.state.value === "" || this.state.key === "") ? true : false} onClick={this.save.bind(this)}>Save</button>
          {this.props.data.id &&
            <button onClick={() => this.setState({ isDeleting: (this.state.isDeleting) ? false : true })}>Remove</button>
          }
        </div>
        <ConfirmModal message="Are you sure you want to remove this network?<br/>" isOpen={this.state.isDeleting}
          data={""}
          onOkay={(data) => {
            this.remove(data)
          }}
          onCancel={() => {
            this.setState({
              isDeleting: false
            })
          }} />
      </div>
    );
  }
}

class AboutWorkEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      work: this.props.work,
      isEditting: (this.props.isNew && !this.props.work.id) ? true : false,
      isDeleting: false
    }
  }

  remove() {
    const _that = this
    const dataTo = {
      id: this.props.work.id
    }

    FakeData.post("/deleteWorkplace.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({ isDeleting: false });
      }),
      error: ((err) => {

      })
    }, true, "Data Removed!", ((res) => { }))
  }

  render() {
    const work = this.state.work
    return (
      <div className={"work-about " + this.props.class}>
        <div className="work-about-head">
          <div>
            <h4>{work.name}</h4>
            {work.name !== "" &&
              <span>{work.position} | {work.period.from + " - " + work.period.to} | {work.city}</span>
            }
          </div>
          {this.props.isAdmin &&
            <i className="material-icons" onClick={() => this.setState({ isEditting: (this.state.isEditting) ? false : true })}>edit</i>
          }
          {this.props.isAdmin &&
            <i className="material-icons" onClick={() => this.setState({ isDeleting: (this.state.isDeleting) ? false : true })}>delete</i>
          }
        </div>
        {this.state.isEditting &&
          <div className="work-about-body">
            <div className="work-about-body-field">
              <span>Company:</span>
              <input value={work.name} onChange={(e) => {
                const val = e.target.value
                this.state.work.name = val
                this.setState({ work: this.state.work });
              }} />
              {!this.props.isNew &&
                <button>Change</button>
              }
            </div>
            <div className="work-about-body-field">
              <span>Position:</span>
              <input value={work.position} onChange={(e) => {
                const val = e.target.value
                this.state.work.position = val
                this.setState({ work: this.state.work });
              }} />
              {!this.props.isNew &&
                <button>Change</button>
              }
            </div>
            <div className="work-about-body-field">
              <span>City/Town:</span>
              <Geosuggest inputClassName="place-input-field" placeholder="" ref={(ref) => this.placeElem = ref} highlightMatch={true} onSuggestSelect={(item) => {
                const val = item.label
                this.state.work.city = val
                this.setState({ work: this.state.work });
                if (this.placeElem != null) {
                  this.placeElem.blur()
                }
              }} />

              {!this.props.isNew &&
                <button>Change</button>
              }
            </div>
            <div className="work-about-body-field">
              <span>Period:</span>
              <div className="period-picker">

                <DatePicker withMonth={true} withYear={true} onChangeDate={(d) => {
                  this.state.work.period.from = d
                  this.setState({ work: this.state.work });
                }} />
                <span>to</span>

                <DatePicker withMonth={true} withYear={true} andSomeValue={"Present"} onChangeDate={(d) => {
                  this.state.work.period.to = d
                  this.setState({ work: this.state.work });
                }} />
              </div>
              {!this.props.isNew &&
                <button>Change</button>
              }
            </div>
            {this.props.isNew &&
              <button disabled={(work.name === "" || work.position === "" || work.city === "" || work.period.from === "" || work.period.to === "") ? true : false} onClick={() => {
                this.props.onWorkSave(this.state.work, () => this.setState({ isEditting: (this.state.isEditting) ? false : true }))
              }}>Save</button>
            }
          </div>
        }
        <ConfirmModal message="Are you sure you want to remove this workplace?<br/>" isOpen={this.state.isDeleting}
          data={""}
          onOkay={(data) => {
            this.remove(data)
          }}
          onCancel={() => {
            this.setState({
              isDeleting: false
            })
          }} />
      </div>
    );
  }
}

class AboutCollegeEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      college: this.props.college,
      isEditting: (this.props.isNew && !this.props.college.id) ? true : false
    }
  }
  remove() {
    const _that = this
    const dataTo = {
      id: this.props.college.id
    }

    FakeData.post("/deleteSchool.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({ isDeleting: false });
      }),
      error: ((err) => {

      })
    }, true, "Data Removed!", ((res) => { }))
  }

  render() {
    const college = this.state.college
    return (
      <div className={"work-about " + this.props.class}>
        <div className="work-about-head">
          <div>
            <h4>{college.name}</h4>
            {college.name !== "" &&
              <span>{college.city}</span>
            }
          </div>
          {this.props.isAdmin &&
            <i className="material-icons" onClick={() => this.setState({ isEditting: (this.state.isEditting) ? false : true })}>edit</i>
          }
          {this.props.isAdmin &&
            <i className="material-icons" onClick={() => this.setState({ isDeleting: (this.state.isDeleting) ? false : true })}>delete</i>
          }
        </div>
        {this.state.isEditting &&
          <div className="work-about-body">
            <div className="work-about-body-field">
              <span>{this.props.label}:</span>
              <input value={college.name} onChange={(e) => {
                const val = e.target.value
                this.state.college.name = val
                this.setState({ college: this.state.college });
              }} />
              {!this.props.isNew &&
                <button>Change</button>
              }
            </div>
            <div className="work-about-body-field">
              <span>City/Town:</span>
              <Geosuggest inputClassName="place-input-field" placeholder="" ref={(ref) => this.placeElem = ref} highlightMatch={true} onSuggestSelect={(item) => {
                const val = item.label
                this.state.college.city = val
                this.setState({ college: this.state.college });
                if (this.placeElem != null) {
                  this.placeElem.blur()
                }
              }} />
              {!this.props.isNew &&
                <button>Change</button>
              }
            </div>
            <div className="work-about-body-field">
              <span>Period:</span>
              <div className="period-picker">

                <DatePicker withMonth={true} withYear={true} onChangeDate={(d) => {
                  this.state.college.period.from = d
                  this.setState({ college: this.state.college });
                }} />
                <span>to</span>

                <DatePicker withMonth={true} withYear={true} andSomeValue={"Present"} onChangeDate={(d) => {
                  this.state.college.period.to = d
                  this.setState({ college: this.state.college });
                }} />
              </div>
              {!this.props.isNew &&
                <button>Change</button>
              }
            </div>
            {this.props.isNew &&
              <button disabled={(college.name === "" || college.city === "" || college.period.from === "" || college.period.to === "") ? true : false} onClick={() => {
                this.props.onCollgeSave(this.state.college, () => this.setState({ isEditting: (this.state.isEditting) ? false : true }))
              }}>Save</button>
            }
          </div>
        }
        <ConfirmModal message="Are you sure you want to remove this school?<br/>" isOpen={this.state.isDeleting}
          data={""}
          onOkay={(data) => {
            this.remove(data)
          }}
          onCancel={() => {
            this.setState({
              isDeleting: false
            })
          }} />
      </div>
    );
  }
}

class AboutHometownEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      city: this.props.city,
      isEditting: false,
      value: ""
    }
  }

  onSave() {
    const _that = this
    const dataTo = {
      id: this.props.fieldId,
      field: this.props.field,
      value: this.state.value
    }

    FakeData.post("/updateMetaData.php?auth0", dataTo, {
      success: ((res) => {
        _that.state = {
          isEditting: false
        }
        //console.log(res)
      }),
      error: ((err) => {

      })
    }, true, "Data Saved!", ((res) => {

    }))
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      city: nextProps.city
    });
  }


  render() {
    const city = this.state.city
    return (
      <div className={"work-about " + this.props.class}>
        <div className="work-about-head">
          <div>
            <h4>{this.props.title}</h4>
            <span>{this.state.city.name}</span>
          </div>
          {this.props.isAdmin &&
            <i className="material-icons" onClick={() => this.setState({ isEditting: (this.state.isEditting) ? false : true })}>edit</i>
          }
        </div>
        {this.state.isEditting &&
          <div className="work-about-body">
            <div className="work-about-body-field">
              <Geosuggest inputClassName="place-input-field" placeholder="" ref={(ref) => this.placeElem = ref} highlightMatch={true} onSuggestSelect={(item) => {
                const val = item.label
                this.setState({ value: val });
                if (this.placeElem != null) {
                  this.placeElem.blur()
                }
              }} />
              {!this.props.isNew &&
                <button>Change</button>
              }
            </div>
            {this.props.isNew &&
              <button style={{ marginLeft: "0px", width: "80%" }} disabled={(city.name === "") ? true : false} onClick={() => {
                this.onSave()
              }}>Save</button>
            }
          </div>
        }
      </div>
    );
  }
}

class AboutCityEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      city: this.props.city,
      isEditting: (this.props.isNew && !this.props.city.id) ? true : false
    }
  }

  remove() {
    const _that = this
    const dataTo = {
      id: this.props.city.id
    }

    FakeData.post("/deletePlace.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({ isDeleting: false });
      }),
      error: ((err) => {

      })
    }, true, "Data Removed!", ((res) => { }))
  }

  render() {
    const city = this.state.city
    return (
      <div className={"work-about " + this.props.class}>
        <div className="work-about-head">
          <div>
            {city.name !== "" &&
              <span>{city.name}</span>
            }
          </div>
          {this.props.isAdmin &&
            <i className="material-icons" onClick={() => this.setState({ isEditting: (this.state.isEditting) ? false : true })}>edit</i>
          }
          {this.props.isAdmin &&
            <i className="material-icons" onClick={() => this.setState({ isDeleting: (this.state.isDeleting) ? false : true })}>delete</i>
          }
        </div>
        {this.state.isEditting &&
          <div className="work-about-body">
            <div className="work-about-body-field">
              <Geosuggest inputClassName="place-input-field" placeholder="" ref={(ref) => this.placeElem = ref} highlightMatch={true} onSuggestSelect={(item) => {
                const val = item.label;
                //console.log(item)
                this.state.city.name = val
                this.state.city.coord.lon = item.location.lng
                this.state.city.coord.lat = item.location.lat
                this.state.city.place_id = item.placeId
                this.setState({ city: this.state.city });
                if (this.placeElem != null) {
                  this.placeElem.blur()
                }
              }} />
              {!this.props.isNew &&
                <button>Change</button>
              }
            </div>
            {this.props.isNew &&
              <button style={{ marginLeft: "0px", width: "80%" }} disabled={(city.name === "") ? true : false} onClick={() => {
                this.props.onCitySave(this.state.city, () => this.setState({ isEditting: false }))
              }}>Save</button>
            }
          </div>
        }
        <ConfirmModal message="Are you sure you want to remove this place?<br/>" isOpen={this.state.isDeleting}
          data={""}
          onOkay={(data) => {
            this.remove(data)
          }}
          onCancel={() => {
            this.setState({
              isDeleting: false
            })
          }} />
      </div>
    );
  }
}

class ClubSportsList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isAdding: false,
      isManaging: false,
      itemToDelete: null
    }
  }

  remove(data) {
    const _that = this;
    const dataTo = {
      id: data.rawId
    }

    FakeData.post("/deleteClubSport.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({ isDeleting: false, itemToDelete: null });
      }),
      error: ((err) => {

      })
    }, true, "Data Removed!", ((res) => { }))
  }

  render() {
    return (
      <div className="my-sports-list">
        {this.props.isAdmin &&
          <div className="my-sports-list-head">
            <div className="my-sports-list-head-item add_album" onClick={() => this.setState({ isAdding: true })}>
              <span>Add Sport</span>
            </div>
            <div className="my-sports-list-head-item manage_photos" onClick={() => this.setState({ isManaging: (this.state.isManaging) ? false : true })}>
              <span>{(this.state.isManaging) ? "Cancel" : "Manage Sports"}</span>
            </div>
          </div>
        }
        <div className="my-sports-list-body">
          {
            this.props.sports.map((item, i) => {
              return (
                <div key={i} data-name={item.name} className={(this.state.isManaging) ? "is-managing" : ""}>
                  {this.state.isManaging &&
                    <span onClick={() => this.setState({ isDeleting: (this.state.isDeleting) ? false : true, itemToDelete: item })}>&times;</span>
                  }
                  <img src={item.image.replace("_wht", "")} />
                </div>
              )
            })
          }
        </div>
        <AddSportFollow isClub={true} type={this.props.type} sports={this.props.sports} isOpen={this.state.isAdding} to={this.props.id} onClose={(arr) => this.setState({ isAdding: false })} />
        {//<AddSportPlay isOpen={this.state.isAddingPlay} onClose={this.onSportsPlayAdd.bind(this)}/>
        }
        {this.state.itemToDelete !== null &&
          <ConfirmModal message="Are you sure you want to remove this sport?<br/>" isOpen={this.state.isDeleting}
            data={this.state.itemToDelete}
            onOkay={(data) => {
              this.remove(data)
            }}
            onCancel={() => {
              this.setState({
                isDeleting: false,
                itemToDelete: null
              })
            }} />
        }
      </div>
    );
  }
}

class UserSportsList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isAdding: false,
      isManaging: false,
      itemToDelete: null
    }
  }

  remove(data) {
    const _that = this;
    const dataTo = {
      id: data.rawId
    }

    //console.log(dataTo)

    FakeData.post("/deleteSportFollow.php?auth0", dataTo, {
      success: ((res) => {
        //console.log(res)
        _that.setState({ isDeleting: false, itemToDelete: null });
      }),
      error: ((err) => {

      })
    }, true, "Data Removed!", ((res) => { }))
  }

  render() {
    return (
      <div className="my-sports-list">
        {this.props.isAdmin &&
          <div className="my-sports-list-head">
            <div className="my-sports-list-head-item add_album" onClick={() => this.setState({ isAdding: true })}>
              <span>Add Sport</span>
            </div>
            <div className="my-sports-list-head-item manage_photos" onClick={() => this.setState({ isManaging: (this.state.isManaging) ? false : true })}>
              <span>{(this.state.isManaging) ? "Cancel" : "Manage Sports"}</span>
            </div>
          </div>
        }
        <div className="my-sports-list-body">
          {
            this.props.sports.map((item, i) => {
              return (
                <div key={i} data-name={item.name} className={(this.state.isManaging) ? "is-managing" : ""}>
                  {this.state.isManaging &&
                    <span onClick={() => this.setState({ isDeleting: (this.state.isDeleting) ? false : true, itemToDelete: item })}>&times;</span>
                  }
                  <img src={item.image.replace("_wht", "")} />
                </div>
              )
            })
          }
        </div>
        <AddSportFollow sports={this.props.sports} isExtending={true} isOpen={this.state.isAdding} to={this.props.id} onClose={(arr) => this.setState({ isAdding: false })} />
        {//<AddSportPlay isOpen={this.state.isAddingPlay} onClose={this.onSportsPlayAdd.bind(this)}/>
        }
        {this.state.itemToDelete !== null &&
          <ConfirmModal message="Are you sure you want to remove this sport?<br/>" isOpen={this.state.isDeleting}
            data={this.state.itemToDelete}
            onOkay={(data) => {
              this.remove(data)
            }}
            onCancel={() => {
              this.setState({
                isDeleting: false,
                itemToDelete: null
              })
            }} />
        }
      </div>
    );
  }
}

class UserTeamsList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isAdding: false
    }
  }

  getTeams(arr) {
    const list = []
    const sports = []
    arr.forEach((item, i) => {
      if (sports.indexOf(item.sport) === -1) {
        if (item.sport !== "") {
          sports.push(item.sport)
        }
      }
    });

    sports.forEach((item, i) => {
      const obj = {
        key: item,
        data: this.getTeamsFor(item, arr)
      }

      list.push(obj)
    });

    return list;
  }

  getTeamsFor(key, arr) {
    const list = []
    arr.forEach((item, i) => {
      if (item.sport === key) {
        list.push(item)
      }
    })
    return list;
  }

  render() {
    const sports = this.getTeams(this.props.teams)
    return (
      <div className="my-sports-list">
        {this.props.isAdmin &&
          <div className="my-sports-list-head">
            <div className="my-sports-list-head-item add_album" onClick={() => this.setState({ isAdding: true })}>
              <span>Add Team</span>
            </div>
            <div className="my-sports-list-head-item manage_photos" onClick={() => this.setState({ isAdding: true, isManaging: true })}>
              <span>Manage Teams</span>
            </div>
          </div>
        }
        <div className="my-teams-list-body">
          {
            sports.map((item, i) => {
              return (
                <div key={i} className="my-teams-list-body-item">
                  <span>{item.key} : </span>
                  <div>
                    {
                      item.data.map((team, x) => {
                        return (
                          <Link to={"/team/" + team.id} key={x}>
                            <img src={team.image} />
                          </Link>
                        )
                      })
                    }
                  </div>
                </div>
              )
            })
          }
          {sports.length === 0 &&
            <div>No teams found!</div>
          }
        </div>
        <ManageTeam isManaging={this.state.isManaging} user={this.props.user} isFollowing={(this.props.category === "mine") ? false : true} myTeams={this.props.teams} isOpen={this.state.isAdding} onClose={() => this.setState({ isAdding: false, isManaging: false })} />
      </div>
    );
  }
}

class FamilyMember extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditting: false,
      user: this.props.user,
      privacy: this.props.user.privacy,
      isDeleting: false,
      isShowingMore: false
    }
  }

  changePrivacy() {
    const _that = this
    const dataTo = {
      id: this.props.user.rawId,
      value: this.state.privacy
    }

    FakeData.post("/changeRelationshipPrivacy.php?auth0", dataTo, {
      success: ((res) => {
        //console.log(res)
      }),
      error: ((err) => {

      })
    }, true, "Data Saved!", ((res) => { }))
  }

  remove() {
    const _that = this
    const dataTo = {
      id: this.props.user.rawId
    }

    FakeData.post("/deleteRelationship.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({ isDeleting: false });
      }),
      error: ((err) => {

      })
    }, true, "Data Removed!", ((res) => { }))
  }

  render() {
    const { user, isRole } = this.props;
    //console.log(this.props)
    return (
      <div className="family-member" tabIndex="0" ref={(ref) => this.elem = (ref === null) ? this.elem : ref} onFocus={(e) => {
        if (this.state.isEditting) {
          e.preventDefault()
        }
      }} onContextMenu={(e) => {
        if (this.state.isEditting) {
          e.preventDefault()
        }
        this.elem.focus();
        e.preventDefault()
      }}>
        <div className="family-member-user">
          <img className="avatar" src={user.image} />
          <div>
            <p>{user.name}</p>
            {!this.props.isRole && <span>{(user.status) ? "Pending" : user.type}</span>}
            {this.props.isRole && <span>{user.status}</span>}
          </div>
          {this.state.isEditting &&
            <PublicityPicker onChange={(e) => {
              const _that = this
              _that.setState({ privacy: e, isEditting: false });
              _that.changePrivacy()
            }} />
          }
          {isRole &&
            <div className="family-member-user-hover-card">
              {user.phone && user.phone !== "" &&
                <span>Phone : <a href={"tel:" + user.phone}>{user.phone}</a><br /></span>
              }
              <span>Email : <a href={"mailto:" + user.email}>{user.email}</a></span>
            </div>
          }
        </div>
        {this.props.isAdmin &&
          <div className="family-member-menu">
            {!this.state.isEditting &&
              <span onClick={() => {
                this.setState({ isDeleting: true })
                this.elem.blur()
              }}>Remove Member</span>
            }
            {!this.state.isEditting &&
              <span onClick={() => {
                this.setState({ isEditting: true })
                this.elem.blur()
              }}>Change Privacy</span>
            }

            {this.state.isEditting &&
              <span onClick={() => {
                this.setState({ isEditting: false })
                this.elem.blur()
              }}>Cancel</span>
            }
          </div>
        }
        <ConfirmModal message="Are you sure you want to remove this member?<br/>" isOpen={this.state.isDeleting}
          data={""}
          onOkay={(data) => {
            this.remove(data)
          }}
          onCancel={() => {
            this.setState({
              isDeleting: false
            })
          }} />
      </div>
    );
  }
}

class SportPlayedView extends Component {
  constructor(p) {
    super(p)
    this.state = {
      startIndex: 0,
      endIndex: 7,
      active: this.props.sports[0],
      activeTeam: null
    }
  }

  getSportGoalTerm(name) {
    const term = (name === "Rugby") ? "Tries" : (name === "Cricket") ? "Runs" : "Goals"
    return term
  }

  getTeams(sport, teams) {
    const arr = [];
    teams.forEach((item, i) => {
      if (item.sport === sport) {
        arr.push(item)
      }
    });

    return arr;
  }

  render() {
    const them = this.props.profile
    const teams = this.getTeams(this.state.active.name, them.myTeams)
    return (
      <div className="sport-played-view">
        {them.isAdmin &&
          <div className="my-sports-list-head">
            <div className="my-sports-list-head-item add_album" onClick={() => this.setState({ isAdding: true })}>
              <span>Add Sport</span>
            </div>
            <div className="my-sports-list-head-item manage_photos" onClick={() => this.setState({ isManaging: (this.state.isManaging) ? false : true })}>
              <span>Manage Sports</span>
            </div>
          </div>
        }

        <div className="sport-played-view-head">
          <div className="my-sports-items">
            {this.props.sports.length > 8 &&
              <div className="my-sports-items-arrow" onClick={() => {
                const _that = this
                let st = _that.state.startIndex;
                let en = _that.state.endIndex;
                if ((st === 0) || (st - 1 < 0)) {
                  return;
                }

                this.setState({
                  startIndex: st - 1,
                  endIndex: en - 1
                });
              }}>
                <img src="images/down_arrow_wht.svg" />
              </div>
            }
            <div className="my-sports-items-content">
              {
                this.props.sports.map((item, i) => {
                  if (i < this.state.startIndex || i > this.state.endIndex) {
                    return null
                  }
                  return (
                    <div data-name={item.name} key={i} className={(this.state.active.id === item.id) ? "active" : ""} onClick={() => this.setState({ active: item, activeTeam: null })}>
                      <img src={item.image.replace("_wht", "")} />
                    </div>
                  )
                })
              }
            </div>
            {this.props.sports.length > 8 &&
              <div className="my-sports-items-arrow" onClick={() => {
                const _that = this
                let st = _that.state.startIndex;
                let en = _that.state.endIndex;
                if ((en + 1 > _that.props.sports.length) || (en === _that.props.sports.length)) {
                  return;
                }

                this.setState({
                  startIndex: st + 1,
                  endIndex: en + 1
                });
              }}>
                <img src="images/down_arrow_wht.svg" />
              </div>
            }
          </div>
          <div className="my-sports-dots">
            {
              this.props.sports.map((item, i) => {
                return (
                  <div key={i}>

                  </div>
                )
              })
            }
          </div>
        </div>
        <div className="sport-played-view-body">
          <div className="sport-played-view-body-head">
            <div className="sport-played-view-body-head-item">
              <span>0</span>
              <span>{this.getSportGoalTerm(this.state.active.name)}</span>
            </div>
            <div className="sport-played-view-body-head-item">
              <span>0</span>
              <span>Matches</span>
            </div>
            <div className="sport-played-view-body-head-item">
              <span>0</span>
              <span>Minutes</span>
            </div>
          </div>
          <div className="sport-played-view-body-body">
            <div className="sport-details">
              <div>
                <div className="sport-detail">
                  <span>Position</span>
                  <span>{(this.state.activeTeam !== null && this.state.activeTeam.position !== "") ? this.state.activeTeam.position : this.state.active.stats.position}</span>
                </div>
                <div className="sport-detail">
                  <span>Height</span>
                  <span>{them.basicInfo[3].value}</span>
                </div>
                <div className="sport-detail">
                  <span>Weight</span>
                  <span>{them.basicInfo[4].value}</span>
                </div>
                <div className="sport-detail">
                  <span>Age</span>
                  <span>{them.age}</span>
                </div>
                <div className="sport-detail">
                  <span>D.O.B</span>
                  <span>{them.dob}</span>
                </div>
                {(teams.length <= 1) &&
                  <div className="sport-detail">
                    <span>Current Team</span>
                    <span>{(teams.length >= 1) ? teams[0].name : "Not set"}</span>
                  </div>
                }
                {(teams.length > 1) &&
                  <div className="sport-detail" style={{ alignItems: "flex-start" }}>
                    <span>Current Team</span>
                    <TeamsMiniSlider onSetActiveTeam={(t) => this.setState({ activeTeam: t })} filter={this.state.active.name} teams={them.myTeams} />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <AddSportPlay to={them.id} sports={them.mySport} isExtending={true} isOpen={this.state.isAdding} onClose={(arr) => this.setState({ isAdding: false })} />
        <ManageSport to={them.id} sports={them.mySport} isExtending={true} isOpen={this.state.isManaging} onClose={(arr) => this.setState({ isManaging: false })} />
      </div>
    );
  }
}

class TeamsMiniSlider extends Component {
  constructor(p) {
    super(p)
    this.state = {
      active: {}
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.filter !== nextProps.filter) {
      this.setState({
        active: {}
      });
    }
  }

  getTeams() {
    const arr = [];
    this.props.teams.forEach((item, i) => {
      if (item.sport === this.props.filter) {
        arr.push(item)
      }
    });

    return arr;
  }

  render() {
    const teams = this.getTeams()
    return (
      <div className="teams-min-slider">
        <span style={{ color: "#000" }}>{(this.state.active.id) ? this.state.active.name : teams[0].name}</span>
        <div className="teams-min-slider-dots">
          {
            teams.map((item, i) => {
              return (
                <span key={i} className={(this.state.active.id && this.state.active.id === item.id) ? "active" : ""} onClick={() => {
                  this.setState({
                    active: item
                  });

                  this.props.onSetActiveTeam(item)
                }}></span>
              )
            })
          }
        </div>
      </div>
    );
  }
}

class ManageSport extends Component {
  constructor(p) {
    super(p)
    this.state = {
      data: this.props.sports
    }
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} onClose={this.props.onClose}>
        <div className="add-place">
          <h1>Edit Your Sports</h1>
          <div className="manage-sport-items">
            {
              this.state.data.map((item, i) => {
                return (
                  <ManageSportItem key={i} sport={item} to={this.props.to} />
                )
              })
            }
          </div>
        </div>
      </Modal>
    );
  }
}

class ManageSportItem extends Component {
  constructor(p) {
    super(p)
    this.state = {
      data: this.props.sport,
      isDeleting: false,
      isEditting: false
    }
  }

  onChange(e) {
    const val = e.target.value
    this.state.data.stats.position = val
    this.setState({ data: this.state.data });
  }

  remove() {
    const _that = this;
    const dataTo = {
      id: this.props.sport.rawId
    }

    FakeData.post("/deleteSportPlayed.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({ isDeleting: false });
      }),
      error: ((err) => {

      })
    }, true, "Data Removed!", ((res) => { }))
  }

  save() {
    //updateSportPosition.php
    const _that = this;
    const dataTo = {
      sportId: this.props.sport.rawId,
      value: this.state.data.stats.position
    }

    FakeData.post("/updateSportPosition.php?auth0", dataTo, {
      success: ((res) => {
        _that.setState({ isEditting: false });
      }),
      error: ((err) => {

      })
    }, true, "Data Saved!", ((res) => { }))
  }

  render() {
    const item = this.state.data
    return (
      <div className="manage-sport-item">
        <img src={item.image.replace("_wht", "")} />
        <div>
          {!this.state.isEditting &&
            <span>{item.stats.position}</span>
          }
          {this.state.isEditting &&
            <input value={item.stats.position} onChange={this.onChange.bind(this)} />
          }
        </div>
        {!this.state.isEditting &&
          <i className="material-icons" onClick={() => this.setState({ isEditting: true })}>edit</i>
        }
        {this.state.isEditting &&
          <i className="material-icons" onClick={() => this.setState({ isEditting: false })}>close</i>
        }
        {!this.state.isEditting &&
          <i className="material-icons" onClick={() => this.setState({ isDeleting: true })}>delete</i>
        }
        {this.state.isEditting &&
          <i className="material-icons" onClick={this.save.bind(this)}>save</i>
        }
        <ConfirmModal message="Are you sure you want to remove this sport?<br/>" isOpen={this.state.isDeleting}
          data={""}
          onOkay={(data) => {
            this.remove()
          }}
          onCancel={() => {
            this.setState({
              isDeleting: false
            })
          }} />
      </div>
    );
  }
}

class ManageTeam extends Component {
  constructor(p) {
    super(p)
    this.state = {
      data: (this.props.isManaging) ? this.props.myTeams : [],
      rawData: (this.props.isManaging) ? this.props.myTeams : [],
      val: "",
      sport: "",
      pos: ""
    }
  }

  componentDidMount() {
    if (!this.props.isManaging) {
      this.setState({ data: (FakeData.getData("all_teams")) ? FakeData.getData("all_teams") : [], rawData: (FakeData.getData("all_teams")) ? FakeData.getData("all_teams") : [] });
    }
  }

  inMine(team) {
    let bool = false;
    //console.log(team)
    for (let x = 0; x < this.props.myTeams.length; x++) {
      if (this.props.myTeams[x].id === team.id) {
        bool = true;
        break;
      }
    }

    return bool;
  }

  onSportChange(e) {
    const val = e.target.value
    this.setState({ sport: val });
    const list = [];
    this.state.rawData.forEach((item, i) => {
      if (item.sport !== null && item.sport.toLowerCase().indexOf(val.toLowerCase()) > -1 && item.name.toLowerCase().indexOf(this.state.val.toLowerCase()) > -1) {
        list.push(item)
        this.setState({ data: list });
      }
    })
  }

  onSearch(e) {
    const val = e.target.value
    this.setState({ val: val });
    const list = [];
    this.state.rawData.forEach((item, i) => {
      if (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1 && item.sport !== null && item.sport.toLowerCase().indexOf(this.state.sport.toLowerCase()) > -1) {
        list.push(item)
        this.setState({ data: list });
      }
    })
  }

  follow(team) {
    const _that = this;
    const dataTo = {
      userId: this.props.user.id,
      teamId: team.id
    }

    FakeData.post("/followTeam.php?auth0", dataTo, {
      success: ((res) => {
        _that.refresh()
      }),
      error: ((e) => {

      })
    }, true, "Data Saved!", ((e) => { }))
  }

  playFor(team) {
    const _that = this;
    const dataTo = {
      userId: this.props.user.id,
      teamId: team.id,
      pos: this.state.pos
    }

    if (this.state.pos === "" && !this.props.isManaging) {
      this.setState({ error: true });
      return;
    }

    FakeData.post("/playForTeam.php?auth0", dataTo, {
      success: ((res) => {
        _that.refresh()
        _that.setState({ pos: "" })
      }),
      error: ((e) => {

      })
    }, true, "Data Saved!", ((e) => { }))
  }

  refresh() {
    const list = [];
    this.state.rawData.forEach((item, i) => {
      if (item.name.toLowerCase().indexOf(this.state.val.toLowerCase()) > -1 && item.sport !== null && item.sport.toLowerCase().indexOf(this.state.sport.toLowerCase()) > -1) {
        list.push(item)
        this.setState({ data: list });
      }
    })
  }

  render() {
    const sports = (FakeData.getData("all_sports")) ? FakeData.getData("all_sports") : []
    return (
      <Modal isOpen={this.props.isOpen} onClose={this.props.onClose}>
        <div className="add-place" style={{ width: "600px" }}>
          <h1>Manage Teams</h1>
          <input list="sports" placeholder={"Select Sport"} style={{ width: "100%", padding: "4px" }} onChange={this.onSportChange.bind(this)} />
          <datalist id="sports">
            {
              sports.map((item, i) => {
                return (
                  <option value={item.name} key={i} />
                )
              })
            }
          </datalist>
          <br />
          <input placeholder={"Enter Team Name"} style={{ width: "100%", padding: "4px", margin: "10px 0px" }} onChange={this.onSearch.bind(this)} />
          {(!this.props.isFollowing && !this.props.isManaging) &&
            <input className={(this.state.error) ? "error" : ""} placeholder={"Enter Your Position"} style={{ width: "100%", padding: "4px", margin: "10px 0px" }} onChange={(e) => {
              const v = e.target.value
              this.setState({ error: false, pos: v });
            }} />
          }

          <div className="manage-teams-items">
            {
              this.state.data.map((item, i) => {
                if ((!this.inMine(item) && this.props.isManaging)) {
                  return null;
                }

                if ((this.inMine(item) && !this.props.isManaging)) {
                  return null;
                }

                return (
                  <div key={i} className="manage-teams-item">
                    <img src={item.image} />
                    <span>{item.name}</span>
                    <button onClick={() => {
                      if (this.props.isFollowing) {
                        this.follow(item)
                      } else {
                        this.playFor(item)
                      }
                    }}>{(this.inMine(item)) ? (this.props.isFollowing ? "Unfollow" : "Remove") : (this.props.isFollowing ? "Follow" : "Add")} Team</button>
                  </div>
                )
              })
            }
          </div>
        </div>
      </Modal>
    );
  }
}

export class AdditionalInformation extends Component {
  state = {
    isAdding: false
  }

  getKeys = (obj = {}) => {
    return Object.keys(obj)
  }

  render = () => {
    const { type, profile, isAdmin, isMedical } = this.props;
    const { isAdding } = this.state;
    const userType = type;
    const userId = profile.id;
    const _dummy = {
      Allergies: ["Meat", "Milk"],
      Injuries: [],
      Medication: []
    }

    return (
      <div className={"additional-info-panel"}>
        <div className={"additional-info-panel-content"}>
          {isMedical &&
            this.getKeys(_dummy).map((item, i) => {
              return (
                <AdditionalInformationItem userId={userId} userType={userType} isAdmin={isAdmin} isNew={false} isMedical={true} key={i} label={item} items={_dummy[item]} />
              )
            })
          }
          {!isMedical &&
            ["People", "Doctors"].map((item, i) => {
              return (
                <AdditionalInformationItem isAdmin={isAdmin} userId={userId} userType={userType} isNew={false} isMedical={false} key={i} label={item} items={[{ name: item, email: item + "@email.io", phone: "0123456789" }]} />
              )
            })
          }
        </div>
      </div>
    )
  }
}

class AdditionalInformationItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditting: false,
      isExpanded: false,
      _text: this.props.label,
      newKey: Date.now(),
      items: []
    }
  }

  componentDidMount() {
    const { isMedical } = this.props;
    this._isMounted = true;
    if (isMedical) {
      this.getMedical();
    } else {
      this.getEmergency();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.state._text.length || !this.state._text.length < 3) {
      return;
    }
  }

  getMedical = () => {
    const { label, items, isNew, isMedical, userId, userType } = this.props;
    const _that = this;
    const _data = {
      userId,
      userType,
      label
    }

    if (!this._isMounted) {
      return;
    }

    FakeData.post("/getMedicalRecords.php?auth0", _data, {
      success(res) {
        if (!_that._isMounted) {
          return;
        }
        _that.setState({ items: res });
        setTimeout(() => {
          _that.getMedical()
        }, 1500);
      }
    });
  }

  getEmergency = () => {
    const { label, items, isNew, isMedical, userId, userType } = this.props;
    const _that = this;
    const _data = {
      userId,
      userType,
      label
    }

    if (!this._isMounted) {
      return;
    }

    FakeData.post("/getEmergencyContacts.php?auth0", _data, {
      success(res) {
        if (!_that._isMounted) {
          return;
        }
        _that.setState({ items: res });
        setTimeout(() => {
          _that.getEmergency()
        }, 1500);
      }
    });
  }

  render = () => {
    const { label, isNew, isMedical, userId, userType, isAdmin } = this.props;
    const { isEditting, _text, newKey, items } = this.state;
    const isExpanded = true;
    return (
      <div className={"additional-info-panel-content-item"}>
        <div className={"additional-info-panel-content-item-header"}>
          <span>{isNew ? _text : label}</span>
          {isAdmin &&
            <i className={"material-icons"} onClick={() => {
              this.setState({ isExpanded: true, isEditting: !isEditting, newKey: Date.now() });
            }}>{!isEditting ? "add" : "close"}</i>
          }
          {this.isEditting &&
            <i className={"material-icons"} onClick={() => {
              this.setState({ isExpanded: isEditting ? true : !isExpanded });
            }}>{isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"}</i>
          }
        </div>
        {isExpanded && isMedical &&
          <div className={"additional-info-panel-content-item-body"}>
            {
              items.map((_item, _i) => {
                return (
                  <AdditionalInformationBodyItem isAdmin={isAdmin} userId={userId} userType={userType} label={label} isNew={false} key={_i} item={_item} />
                )
              })
            }
            {items.length === 0 && !isEditting &&
              <EmptyState isShown={true} text={"No " + label + " found!"} style={{ width: "100%", height: "3vw", padding: "5px" }} />
            }
            {isEditting && isAdmin &&
              <AdditionalInformationBodyItem isAdmin={isAdmin} userId={userId} userType={userType} label={label} key={newKey} isNew={true} item={{ value: "new Item" }} callBack={() => {
                this.setState({ isExpanded: true, isEditting: false, newKey: Date.now() });
              }} />
            }
          </div>
        }
        {isExpanded && !isMedical &&
          <div className={"additional-info-panel-content-item-body"}>
            <table className={"table"} style={{ width: "100%" }}>
              <thead style={{ width: "100%" }}>
                <tr className={"additional-info-contact-item"}>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  {label === "People" &&
                    <th>Relation</th>
                  }
                  {isAdmin && <th>Action</th>}
                </tr>
              </thead>
              <tbody style={{ width: "100%" }}>
                {
                  items.map((_item, _i) => {
                    return (
                      <AdditionalInformationContactItem isAdmin={isAdmin} hasRelation={label === "People" ? true : false} userId={userId} userType={userType} label={label} isNew={false} key={_i} item={_item} />
                    )
                  })
                }
                {items.length === 0 && !isEditting &&
                  <tr className={"additional-info-contact-item"}>
                    <td colSpan={isAdmin ? (label === "People" ? 5 : 4) : (label === "People" ? 4 : 3)}>
                      <EmptyState isShown={true} text={"No " + label + " found!"} style={{ width: "100%", height: "5vw", padding: "5px" }} />
                    </td>
                  </tr>
                }
                {isEditting && isAdmin &&
                  <AdditionalInformationContactItem isAdmin={isAdmin} hasRelation={label === "People" ? true : false} userId={userId} userType={userType} label={label} key={newKey} isNew={true} item={{ name: "name", email: "email", phone: "0123456789", relation: "" }} callBack={() => {
                    this.setState({ isExpanded: true, isEditting: false, newKey: Date.now() });
                  }} />
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    )
  }
}

class AdditionalInformationBodyItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _item: this.props.item,
      isEditting: this.props.isNew ? true : false,
      isDeleting: false,
      error: false
    }
  }

  onDelete = () => {
    const { _item } = this.state;
    const _that = this;
    const _data = {
      id: _item.id
    }

    FakeData.post("/deleteMedicalRecord.php?auth0", _data, {
      success(res) {
        if (res.error) {
          FakeData.alert("Couldn't remove data");
          return;
        } else {
          FakeData.alert("Data removed!");
          _that.setState({ isDeleting: false });
        }
      }
    }, true, "", () => { });
  }

  handleSubmit = () => {
    const { item, isNew, callBack, userId, userType, label } = this.props;
    const { isEditting, _item, isDeleting, error } = this.state;
    const _that = this;
    if (!_item.value.length || _item.value.length < 3) {
      this.setState({ error: true });
      return;
    }

    if (isNew) {
      const _data = {
        userId,
        yourId: FakeData.getData("yoo").id,
        userType,
        value: _item.value,
        label
      }

      FakeData.post("/addMedicalRecord.php?auth0", _data, {
        success(res) {
          if (res.error) {
            FakeData.alert("Couldn't save data");
            return;
          } else {
            if (callBack) {
              callBack();
            }
            FakeData.alert("Data saved!");
          }
        }
      }, true, "", () => { });
    } else {
      const url = "/updateTable.php?auth0&ref=medical_info";
      const _field = { Value: _item.value };
      const data = {
        data: _field,
        query: "ID='" + _item.id + "' AND UserID='" + _item.user.id + "' AND UserType='" + _item.user.type + "' AND Label='" + label + "'",
        user: { id: FakeData.getData("yoo").id, type: "F" },
        userTo: { id: userId, type: userType }
      }

      FakeData.post(url, data, {
        success(res) {
          if (res.error) {
            FakeData.alert("Coundn't update data!");
          } else {
            _that.setState({ isEditting: false })
          }
        },
        error(err) {
          FakeData.alert("Coundn't update data!");
          //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
        }
      }, true, "", (t) => { })
    }
  }

  render = () => {
    const { item, isNew, isAdmin } = this.props;
    const { isEditting, _item, isDeleting, error } = this.state;
    return (
      <li>
        <i className={"material-icons"} style={{ color: "#000", fontSize: 5 }}>{"brightness_1"}</i>
        {!isEditting && <span>{isNew ? _item.value : item.value}</span>}
        {isEditting && isAdmin &&
          <form onSubmit={(e) => {
            e.preventDefault();
            this.handleSubmit()
          }}>
            <input className={error ? "error" : ""} value={_item.value} onChange={(w) => {
              _item.value = w.target.value;
              const _error = w.target.value.length < 3 ? true : false
              this.setState({ _item, error });
            }} />
          </form>
        }
        {isNew && isAdmin &&
          <i className={"material-icons"} onClick={this.handleSubmit.bind(this)}>{"save"}</i>
        }
        {!isNew && isAdmin &&
          <i className={"material-icons"} onClick={() => {
            this.setState({ isEditting: !isEditting, isExpanded: false });
          }}>{isEditting ? "save" : "edit"}</i>
        }
        {!isNew && isAdmin &&
          <i className={"material-icons"} onClick={() => {
            this.setState({ isDeleting: true });
          }}>{"delete"}</i>
        }
        {isDeleting && isAdmin &&
          <ConfirmModal message="Are you sure you want to remove this contact?<br/>" isOpen={isDeleting}
            data={_item.id}
            onOkay={(data) => {
              this.onDelete()
            }}
            onCancel={() => {
              this.setState({
                isDeleting: false
              })
            }} />
        }
      </li>
    )
  }
}

class AdditionalInformationContactItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _item: this.props.item,
      isEditting: this.props.isNew ? true : false,
      isDeleting: false,
      errors: {
        name: false,
        email: false,
        phone: false,
        relation: false
      },
      memberTypes: ['mother', 'mom', 'father', 'dad', 'parent', 'children', 'son', 'daughter', 'sister', 'brother', 'grandmother', 'grandfather', 'grandparent', 'grandson', 'granddaughter', 'grandchild', 'aunt', 'uncle', 'niece', 'nephew', 'cousin', 'husband', 'wife', 'sister-in-law', 'brother-in-law', 'mother-in-law', 'father-in-law', 'partner', 'fiancé', 'fiancée', 'stepmother', 'stepfather', 'ex']
    }
  }

  onDelete = () => {
    const { _item } = this.state;
    const _that = this;
    const _data = {
      id: _item.id
    }

    FakeData.post("/deleteEmergencyContact.php?auth0", _data, {
      success(res) {
        if (res.error) {
          FakeData.alert("Couldn't remove data");
          return;
        } else {
          FakeData.alert("Data removed!");
          _that.setState({ isDeleting: false });
        }
      }
    }, true, "", () => { });
  }

  handleSubmit = (field = "", bool = false) => {
    const { isNew, callBack, label, userId, userType } = this.props;
    const { isEditting, _item, errors } = this.state;
    const _that = this;
    if (bool && !isNew) {
      if (field === "email" && !FakeData.isEmail(this.state._item[field])) {
        FakeData.alert("Invalid email!");
        this.state.errors[field] = true;
        this.setState({ errors: this.state.errors });
        return;
      } else if (field === "phone" && !FakeData.isPhone(this.state._item[field])) {
        FakeData.alert("Invalid phone number!");
        this.state.errors[field] = true;
        this.setState({ errors: this.state.errors });
        return;
      } else if (field === "name" && !this.state._item[field].length || this.state._item[field].length < 3) {
        FakeData.alert("Make sure the length of the name field is greater than 3 characters");
        this.state.errors[field] = true;
        this.setState({ errors: this.state.errors });
        return;
      } else if (field === "relation" && !this.state._item.relation.length || this.state._item.relation.length < 3 && this.props.hasRelation) {
        FakeData.alert("Please select relation");
        this.state.errors.relation = true;
        this.setState({ errors: this.state.errors });
        return;
      }

      const url = "/updateTable.php?auth0&ref=emergency_contact";
      const _field = field === "email" ? { Email: _item[field] } : field === "phone" ? { Phone: _item[field] } : field === "relation" ? { Relation: _item[field] } : { Name: _item[field] };
      const data = {
        data: _field,
        query: "ID='" + _item.id + "' AND UserID='" + _item.user.id + "' AND UserType='" + _item.user.type + "' AND Label='" + label + "'",
        user: { id: FakeData.getData("yoo").id, type: "F" },
        userTo: { id: userId, type: userType }
      }

      FakeData.post(url, data, {
        success(res) {
          if (res.error) {
            FakeData.alert("Coundn't update data!");
          } else {
            _that.setState({ isEditting: false })
          }
        },
        error(err) {
          FakeData.alert("Coundn't update data!");
          //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
        }
      }, true, "", (t) => { })
    } else {
      if (isNew) {
        if (!this.state._item.name.length || this.state._item.name.length < 3) {
          FakeData.alert("Make sure the length of the name field is greater than 3 characters");
          this.state.errors.name = true;
          this.setState({ errors: this.state.errors });
          return;
        } else if (!FakeData.isEmail(this.state._item.email)) {
          FakeData.alert("Invalid email!");
          this.state.errors.email = true;
          this.setState({ errors: this.state.errors });
          return;
        } else if (!FakeData.isPhone(this.state._item.phone)) {
          FakeData.alert("Invalid phone number!");
          this.state.errors.phone = true;
          this.setState({ errors: this.state.errors });
          return;
        } else if (!this.state._item.relation.length || this.state._item.relation.length < 3 && this.props.hasRelation) {
          FakeData.alert("Please select relation");
          this.state.errors.relation = true;
          this.setState({ errors: this.state.errors });
          return;
        }

        const _data = {
          userId,
          yourId: FakeData.getData("yoo").id,
          userType,
          name: _item['name'],
          email: _item['email'],
          phone: _item['phone'],
          label
        }

        FakeData.post("/addEmergencyContact.php?auth0", _data, {
          success(res) {
            if (res.error) {
              FakeData.alert("Couldn't save data");
              return;
            } else {
              if (callBack) {
                callBack();
              }
              FakeData.alert("Data saved!");
            }
          }
        }, true, "", () => { });
      } else {
        if (!this.state._item.name.length || this.state._item.name.length < 3) {
          FakeData.alert("Make sure the length of the name field is greater than 3 characters");
          this.state.errors.name = true;
          this.setState({ errors: this.state.errors });
          return;
        } else if (!FakeData.isEmail(this.state._item.email)) {
          FakeData.alert("Invalid email!");
          this.state.errors.email = true;
          this.setState({ errors: this.state.errors });
          return;
        } else if (!FakeData.isPhone(this.state._item.phone)) {
          FakeData.alert("Invalid phone number!");
          this.state.errors.phone = true;
          this.setState({ errors: this.state.errors });
          return;
        } else if (!this.state._item.relation.length || this.state._item.relation.length < 3 && this.props.hasRelation) {
          FakeData.alert("Please select relation");
          this.state.errors.relation = true;
          this.setState({ errors: this.state.errors });
          return;
        }

        const url = "/updateTable.php?auth0&ref=emergency_contact";

        const _data = {
          Name: _item['name'],
          Email: _item['email'],
          Phone: _item['phone'],
          Relation: _item['relation']
        }

        const data = {
          data: _data,
          query: "ID='" + _item.id + "' AND UserID='" + _item.user.id + "' AND UserType='" + _item.user.type + "' AND Label='" + label + "'",
          user: { id: FakeData.getData("yoo").id, type: "F" },
          userTo: { id: userId, type: userType }
        }

        FakeData.post(url, data, {
          success(res) {
            if (res.error) {
              FakeData.alert("Coundn't update data!");
            } else {
              _that.setState({ isEditting: false })
            }
          },
          error(err) {
            FakeData.alert("Coundn't update data!");
            //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
          }
        }, true, "", (t) => { })
      }
    }
  }

  setData = (key, value) => {
    return Object.defineProperty({}, key, {
      value,
      writable: false
    });
  }

  render = () => {
    const { item, isNew, hasRelation, isAdmin } = this.props;
    const { isEditting, _item, errors, isDeleting, memberTypes } = this.state;

    return (
      <tr className={"additional-info-contact-item"}>
        <td>
          {!isEditting && <span style={{ padding: "4px", width: "100%", display: "block" }}>{item.name}</span>}
          {isEditting &&
            <form onSubmit={(e) => {
              e.preventDefault();
              if (isNew) {
                return;
              }
              this.handleSubmit("name", true)
            }}>
              <input className={!errors.name ? "normal-input" : "normal-input error"} value={_item.name} onChange={(w) => {
                _item.name = w.target.value
                errors.name = w.target.value.length < 3 ? true : false
                this.setState({ _item, errors });
              }} />
            </form>
          }
        </td>
        <td>
          {!isEditting && <span style={{ padding: "4px", width: "100%", display: "block" }}>{item.email}</span>}
          {isEditting &&
            <form onSubmit={(e) => {
              e.preventDefault();
              if (isNew) {
                return;
              }
              this.handleSubmit("email", true)
            }}>
              <input className={!errors.email ? "normal-input" : "normal-input error"} value={_item.email} onChange={(w) => {
                _item.email = w.target.value
                errors.email = FakeData.isEmail(w.target.value) ? false : true;
                this.setState({ _item, errors });
              }} />
            </form>
          }
        </td>
        <td>
          {!isEditting && <span style={{ padding: "4px", width: "100%", display: "block" }}>{item.phone}</span>}
          {isEditting &&
            <form onSubmit={(e) => {
              e.preventDefault();
              if (isNew) {
                return;
              }
              this.handleSubmit("phone", true)
            }}>
              <input className={!errors.phone ? "normal-input" : "normal-input error"} value={_item.phone} onChange={(w) => {
                _item.phone = w.target.value
                errors.phone = !FakeData.isPhone(w.target.value)
                this.setState({ _item, errors });
              }} />
            </form>
          }
        </td>
        {hasRelation &&
          <td>
            {!isEditting && <span style={{ padding: "4px", width: "100%", display: "block" }}>{item.relation}</span>}
            {isEditting &&
              <form onSubmit={(e) => {
                e.preventDefault();
                if (isNew) {
                  return;
                }
                this.handleSubmit("relation", true)
              }}>
                <select className={!errors.relation ? "normal-input" : "normal-input error"} value={_item.relation} onChange={(w) => {
                  _item.relation = w.target.value
                  errors.relation = w.target.value.length < 3 ? true : false
                  this.setState({ _item, errors });
                  this.handleSubmit("relation", true)
                }} >
                  <option value="">Select relation</option>
                  {
                    memberTypes.map((item, i) => {
                      return (
                        <option key={i} value={item.capitalize()}>{item.capitalize()}</option>
                      )
                    })
                  }
                </select>
              </form>
            }
          </td>
        }
        {isAdmin &&
          <td>
            {isNew &&
              <i className={"material-icons"} style={{ fontSize: "inherit", color: "#ccc" }} onClick={() => this.handleSubmit("", false)}>{"save"}</i>
            }
            {!isNew &&
              <i className={"material-icons"} style={{ fontSize: "inherit", color: "#ccc", marginRight: 10 }} onClick={() => {
                this.setState({ isEditting: !isEditting });
              }}>{isEditting ? "close" : "edit"}</i>
            }
            {!isNew && isEditting &&
              <i className={"material-icons"} style={{ fontSize: "inherit", color: "#ccc" }} onClick={() => this.handleSubmit("", false)}>{"save"}</i>
            }
            {!isNew && !isEditting &&
              <i className={"material-icons"} style={{ fontSize: "inherit", color: "#ccc" }} onClick={() => {
                this.setState({ isDeleting: true })
              }}>{"delete"}</i>
            }
            {isDeleting &&
              <ConfirmModal message="Are you sure you want to remove this contact?<br/>" isOpen={isDeleting}
                data={_item.id}
                onOkay={(data) => {
                  this.onDelete()
                }}
                onCancel={() => {
                  this.setState({
                    isDeleting: false
                  })
                }} />
            }
          </td>
        }
      </tr>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/About.js